// src/pages/DesignerPage/DesignerPage.js
// DesignerPage BẮT BUỘC phải có cabinetType - chỉ dùng để thiết kế tủ
// Không hỗ trợ chế độ thường, luôn phải thiết kế một loại tủ cụ thể

import {
  createContext,
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from 'react';
import { useParams } from 'react-router-dom';
import WallSetupForm from '../../components/house/WallSetupForm/WallSetupForm';
import HeaderDesign from '../../components/layout/HeaderDesign/HeaderDesign';

import * as THREE from 'three';

// ===== IMPORT MỚI =====
import ExtendedSceneManager from '../../three/scenes/ExtendedSceneManager'; // Thay vì SceneManager

// ===== COMPONENTS CŨ =====
import { Form, message } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
// import LoginModal from '../../components/auth/LoginModal/LoginModal';
import CabinetEditor from '../../components/cabinet/CabinetEditor/CabinetEditor';
import LeftInsideCustomDesignMenu from '../../components/cabinet/LeftInsideCustomDesignMenu/LeftInsideCustomDesignMenu';
import RightInsideDesignMenu from '../../components/cabinet/RightInsideDesignMenu/RightInsideDesignMenu';
import RightBacksplashCustomDesign from '../../components/cabinet/RightBacksplashCustomDesign/RightBacksplashCustomDesign';
import CabinetTrimView from '../../components/cabinetTrim/CabinetTrimView/CabinetTrimView';
import { InsideLoader } from '../../three/loaders/InsideLoader';
import { fetchDuluxPaletes } from '../../store/actions/dulux-palete.action';
import {
  fetchModule,
  fetchPricePermanents,
} from '../../store/actions/module.action';
import {
  InsideType,
  LimitDoor,
  ModuleType,
  SHAPE_TYPES,
  SnapDoor,
  TypeCabinet,
  TypeConnerModule,
} from '../../constants/enum';
import { GeometryUtils } from '../../utils/geometry/GeometryUtils';
import LeftAccessoryDesignMenu from './components/LeftAccessoryDesignMenu/LeftAccessoryDesignMenu';
import LeftCabinetDesignMenu from './components/LeftCabinetDesignMenu/LeftCabinetDesignMenu';
import LeftDoorDesignMenu from './components/LeftDoorDesignMenu/LeftDoorDesignMenu';
import LeftOutsideDesignMenu from './components/LeftOutsideDesignMenu/LeftOutsideDesignMenu';
import LeftPartitionDesignMenu from './components/LeftPartitionDesignMenu/LeftPartitionDesignMenu';
import NavbarDesign from './components/NavbarDesign/NavbarDesign';
import ResizeMenuDesign from './components/ResizeMenuDesign/ResizeMenuDesign';
import RightCabinetDesignMenu from './components/RightCabinetDesignMenu/RightCabinetDesignMenu';
import RightDoorAccessoryDesignMenu from './components/RightDoorAccessoryDesignMenu/RightDoorAccessoryDesignMenu';
import RightDoorWardrobeDesignMenu from './components/RightDoorWardrobeDesignMenu/RightDoorWardrobeDesignMenu';
import RightMaterialMenu from './components/RightMaterialMenu/RightMaterialMenu';
import RoomLibrary from './components/RoomLibrary/RoomLibrary';
import SelectedModel from './components/SelectedModel/SelectedModel';
import SidebarDesign from './components/SidebarDesign/SidebarDesign';
import SliderDesign from './components/SliderDesign/SliderDesign';
import ToolbarDesign from './components/ToolbarDesign/ToolbarDesign';
import DimensionOverlay from '../../components/dimension/DimensionOverlay';
import DimensionToolbar from '../../components/dimension/DimensionToolbar';
import DimensionEditor from '../../components/dimension/DimensionEditor';
import {
  clearDimensions,
  setDimensionEnabled,
  setDimensions,
  setDimensionViews,
} from '../../store/reducers/dimension.reducer';
import {
  buildDimensionPayload,
  buildViewsPayload,
  parseDimensions,
  parseViews,
} from '../../utils/dimension/dimensionSerialize';
import './DesignerPage.scss';
import LeftIslandCabinetDesignMenu from './components/LeftIslandCabinetDesignMenu/LeftIslandCabinetDesignMenu';
import callApi from '../../utils/api/callAPI';
import { captureRoomScreenshot } from '../../utils/canvas/canvasScreenshot';
import { useSearchParams } from 'react-router-dom';
import SaveLibraryDesignModal from './components/SaveLibraryDesignModal/SaveLibraryDesignModal';
import SaveModuleLibraryModal from '../../components/cabinet/CabinetEditor/SaveModuleLibraryModal/SaveModuleLibraryModal';
import LoadingOverlay from '../../components/common/LoadingOverlay/LoadingOverlay';
import { Icon } from '../../components/icon/icon';
import { openMessageSuccess } from '../../components/common/Message/openMessageSuccess';
import { openMessageWarning } from '../../components/common/Message/openMessageWarning';
import { openMessageError } from '../../components/common/Message/openMessageError';
import { nearlyEqual, roundTo } from '../../utils/geometry/epsilon';
import openModalFitHeight from '../../components/common/Modal/openModalConfirmFitHeight';
import { EdgeDetector } from '../../three/core/layout/EdgeDetector';
import RightApplyDoorChangesToAll from '../../components/cabinet/RightApplyDoorChangesToAll/RightApplyDoorChangesToAll';
import { useTranslation } from 'react-i18next';
import { pick } from 'lodash';
import { setCurrentSupplier } from '../../store/reducers/supplier.reducer';
import { getValueFromString } from '../../utils/data/getValue.utils';
import RightCountertopCustomDesign from '../../components/cabinet/RightCountertopCustomDesign/RightCountertopCustomDesign';
import LeftLightingDesignMenu from './components/LeftLightingDesignMenu/LeftLightingDesignMenu';
import RightDoorMirrorDesignMenu from './components/RightDoorMirrorDesignMenu/RightDoorMirrorDesignMenu';
import { useExportExcel } from '../../hooks/useExportExcel';
import { ShortcutUtils } from '../../utils/shortcuts/ShortcutUtils';
import { convertCostDataToExcel } from '../../services/Excel/ConvertToExcel';
import { fetchDefaultPriceConfig } from '../../store/actions/default.config.action';
import RightLiftSupportDesignMenu from './components/RightLiftSupportDesignMenu/RightLiftSupportDesignMenu';
import { fetchLiftSupport } from '../../store/actions/liftSupport.action';
import useRoomPriceContext, {
  refreshRoomPriceData,
} from '../../hooks/useRoomPriceContext';
import {
  fetchDoorHandles,
  fetchGroupDoor,
} from '../../store/actions/door.handle.action';
import { fetchProducts } from '../../store/actions/product.action';

// Dùng chung cho cả DesignerPage và WallSetupForm
const FLOOR_TEXTURES = [
  {
    id: 'wood1',
    label: 'KW105',
    img: '/assets/images/KW105.jpg',
  },
  {
    id: 'wood2',
    label: 'KW108',
    img: '/assets/images/KW108.jpg',
  },
  {
    id: 'wood3',
    label: 'KW118',
    img: '/assets/images/KW118.jpg',
  },
  {
    id: 'wood4',
    label: 'KW139',
    img: '/assets/images/KW139.jpg',
  },
  {
    id: 'wood5',
    label: 'KW165',
    img: '/assets/images/KW165.jpg',
  },
  {
    id: 'wood6',
    label: 'KW388',
    img: '/assets/images/KW388.jpg',
  },
];

export const DesignerPageContext = createContext();

// DesignerPage BẮT BUỘC phải có cabinetType
const DesignerPage = ({}) => {
  const { type } = useParams();

  const [searchParams, setSearchParams] = useSearchParams();
  const product_type = searchParams.get('product_type');
  const design_id = searchParams.get('design_id');
  const sale_product = searchParams.get('sale_product');
  const country_code = process.env.REACT_APP_COUNTRY_CODE ?? 'vn';
  const subType = searchParams.get('sub_type');

  const cabinetType = useMemo(() => {
    if (type === 'decorative') return 'tv';
    // mặc định "kitchen", nếu có type thì dùng type
    return (type || 'kitchen').toLowerCase();
  }, [type]);

  const isKitchenLocked = useMemo(
    () => cabinetType === 'kitchen',
    [cabinetType]
  );

  const { t } = useTranslation();
  const { exportToExcel } = useExportExcel();

  // ===== STATES CŨ (GIỮ NGUYÊN) =====
  const [listModule, setListModule] = useState([]);
  const [sidebarKey, setSidebarKey] = useState({ active: false, key: null });

  const [navbarKey, setNavbarKey] = useState();
  const sceneRef = useRef(null);
  const [sceneData, setSceneData] = useState(null);
  const [sceneManager, setSceneManager] = useState(null);
  const [selectedModel, setSelectedModel] = useState(null);
  const [selectedModelScreenPos, setSelectedModelScreenPos] = useState(null);
  const [isDragging, setIsDragging] = useState(false);

  const [dataDesign, setDataDesign] = useState();

  const [moveButtonPos, setMoveButtonPos] = useState(null);
  const [showMoveButton, setShowMoveButton] = useState(false);
  const [showNavDesign, setShowNavDesign] = useState(false);
  const [showCabinetTrimView, setShowCabinetTrimView] = useState(false);

  const [selectedInsideKey, setSelectedInsideKey] = useState(null);

  const [groupDoorId, setGroupDoorId] = useState(null);
  const { door, groupDoor } = useSelector(state => state.doorAndHandle);

  // ==== Drag & pick refs ====
  const isDraggingRef = useRef(false); // kéo preview từ palette
  const draggedModuleRef = useRef(null);
  const previewModelRef = useRef(null);
  const insideLoaderRef = useRef(null);
  const raycasterRef = useRef(new THREE.Raycaster());
  const mousePositionRef = useRef(new THREE.Vector2());

  const lockedRef = useRef(false);
  const isAnimatingRef = useRef(false);

  const meshClickRef = useRef(null); // mesh/nhóm đang chọn
  const doorCornersRef = useRef([]); // size mesh/nhóm đang chọn
  const childClickRef = useRef(null); // holder (type 10) nếu có

  const isDragInsideRef = useRef(false); // kéo inside
  const isDragInside2Ref = useRef(false); // chặn double-trigger
  const isDragDoorRef = useRef(false); // kéo arrayPointDoor trên cửa
  const isDragHolderRef = useRef(false); // kéo tay nắm/holder

  const prePosRef = useRef(null); // vị trí cũ khi kéo inside
  const pointSnapRef = useRef(null); // snap point khi scale cửa

  const [cbTrim, setCbTrim] = useState({ width: 0.03, height: 0.03 });

  const [tick, setTick] = useState(0); // trigger render nhẹ

  const [appearance, setAppearance] = useState({
    wallColor: '#FCFCFC',
    floorTexId: 'wood6', // khớp với /assets/images/texture1.jpg
    floorRepeat: 4,
  });

  // ===== STATES MỚI CHO CABINET (ĐƠN GIẢN HÓA) =====
  const [currentCabinetType, setCurrentCabinetType] = useState(null);
  const [currentCabinet, setCurrentCabinet] = useState(null);
  const [availableModuleTypes, setAvailableModuleTypes] = useState([]);

  const [showEditForm, setShowEditForm] = useState(false);
  const [editingModule, setEditingModule] = useState(null);
  const [selectedModels, setSelectedModels] = useState([]);
  const [formRightInsideCustomDesignMenu] = Form.useForm();
  const [showCabinetEditor, setShowCabinetEditor] = useState(false);
  const [supplierId, setSupplierId] = useState({});
  const [currentMaterial, setCurrentMaterial] = useState();

  // const [materialType, setMaterialType] = useState(null);
  // const [textureFrame, setTextureFrame] = useState(null);
  const [textureDoor, setTextureDoor] = useState(null);
  // const [openModalLogin, setOpenModalLogin] = useState(false);
  const [openSaveLibraryModal, setOpenSaveLibraryModal] = useState(false);
  const [openRoomLibrary, setOpenRoomLibrary] = useState(false);
  const [showSaveLibraryModule, setShowSaveLibraryModule] = useState(false);
  const [openExampleRecommend, setOpenExampleRecommend] = useState(false);
  const [isDimensioning, setIsDimensioning] = useState(false);
  const [isHideDoor, setIsHideDoor] = useState(false);
  const [isOpenDoor, setIsOpenDoor] = useState(false);
  const [isDesignLibrary, setIsDesignLibrary] = useState(false);
  const [editLibraryData, setEditLibraryData] = useState(null);

  const centerPointRef = useRef(null);
  const snapLineRef = useRef(null);
  const SNAP_THRESHOLD = 0.01;

  const [
    openRightDoorAccessoryDesignMenu,
    setOpenRightDoorAccessoryDesignMenu,
  ] = useState(false);

  const [openRightLiftSupportDesignMenu, setOpenRightLiftSupportDesignMenu] =
    useState(false);

  const [selectedRoomId, setSelectedRoomId] = useState(null);
  const [isLoadingRoom, setIsLoadingRoom] = useState(false);
  const [isLoadingDesign, setIsLoadingDesign] = useState(false);
  const [isLoadingSave, setIsLoadingSave] = useState(false);
  const needUpdatePrice = useRef(false);
  const [currentRoomData, setCurrentRoomData] = useState(null);
  useRoomPriceContext(selectedRoomId);

  const [nameDesign, setNameDesign] = useState(null);
  const [designId, setDesignId] = useState(null);
  const dispatch = useDispatch();
  // DIM luôn đọc từ ref trong các handler lưu để không phải thêm vào deps useCallback
  const dimensionItems = useSelector(state => state.dimension.items);
  const dimensionsRef = useRef(dimensionItems);
  dimensionsRef.current = dimensionItems;
  const dimensionViews = useSelector(state => state.dimension.views);
  const dimensionViewsRef = useRef(dimensionViews);
  dimensionViewsRef.current = dimensionViews;
  useEffect(
    () => () => {
      // Rời trang designer: bỏ DIM của thiết kế hiện tại
      dispatch(clearDimensions());
      dispatch(setDimensionViews([]));
      dispatch(setDimensionEnabled(false));
    },
    [dispatch]
  );
  const navigate = useNavigate();

  const auth = useSelector(state => state.auth);

  const { vnConfig, usConfig } = useSelector(state => state.defaultConfig);
  const { liftSupport } = useSelector(state => state.liftSupport);
  const { products } = useSelector(state => state.product);

  const [mdSelectedModelData, setMdSelectedModelData] = useState({
    mdDimensions: {},
    mdOptions: {},
  });

  const currentProduct = useMemo(() => {
    return products.data?.find(item =>
      item.types.some(type => type.code?.includes(subType))
    );
  }, [products, subType]);

  useEffect(() => {
    if (products.isNeedReloadData && country_code)
      dispatch(fetchProducts({ country_code }));
  }, [products.isNeedReloadData, country_code]);

  useEffect(() => {
    if (groupDoor.isNeedReloadData) {
      dispatch(fetchGroupDoor());
    }
  }, [groupDoor.isNeedReloadData]);

  useEffect(() => {
    if (groupDoor.data?.length) {
      setGroupDoorId(groupDoor.data[0].value);
    }
  }, [groupDoor.data]);

  useEffect(() => {
    dispatch(fetchLiftSupport());
  }, []);

  useEffect(() => {
    if (!product_type || !groupDoorId) return;

    dispatch(
      fetchDoorHandles({
        product_type,
        door_type: 'HINGED',
        orientation: groupDoorId,
      })
    );
  }, [product_type, groupDoorId]);

  useEffect(() => {
    if (!selectedModel?.uuid || !sceneManager?.cabinetManager) {
      // setCurrentProduct(null);
      return;
    }
    const module = sceneManager.cabinetManager.getModuleByGltfUuid(
      selectedModel.uuid
    );
    // setCurrentProduct(module?.moduleData.product_type_id);

    if (module?.moduleData.product_type_id) {
      setSearchParams(prev => {
        const params = Object.fromEntries([...prev]);
        params['product_type'] = module?.moduleData.product_type_id;
        return { ...params };
      });
    }
  }, [selectedModel]);

  useEffect(() => {
    lockedRef.current = isKitchenLocked;
    // dispatch(fetchDuluxPaletes());
  }, [isKitchenLocked]);

  useEffect(() => {
    if (
      sceneManager &&
      Object.keys(vnConfig.priceConfig.data ?? {})?.length &&
      Object.keys(vnConfig.profitConfig.data ?? {})?.length &&
      Object.keys(vnConfig.ruleConfig.data ?? {})?.length
    ) {
      sceneManager.updateDefaultViPriceConfig({
        priceConfig: vnConfig.priceConfig.data,
        profitConfig: vnConfig.profitConfig.data,
        ruleConfig: vnConfig.ruleConfig.data,
      });
    }
  }, [
    sceneManager,
    vnConfig.priceConfig.data,
    vnConfig.profitConfig.data,
    vnConfig.ruleConfig.data,
  ]);

  useEffect(() => {
    if (
      sceneManager &&
      Object.keys(usConfig.priceConfig.data ?? {})?.length &&
      Object.keys(usConfig.profitConfig.data ?? {})?.length &&
      Object.keys(usConfig.ruleConfig.data ?? {})?.length
    ) {
      sceneManager.updateDefaultUsPriceConfig({
        priceConfig: usConfig.priceConfig.data,
        profitConfig: usConfig.profitConfig.data,
        ruleConfig: usConfig.ruleConfig.data,
      });
    }
  }, [
    sceneManager,
    usConfig.priceConfig.data,
    usConfig.profitConfig.data,
    usConfig.ruleConfig.data,
  ]);

  // const selectedModels = useRef();

  //  XÓA: Không cần refs cho cabinet instances nữa
  // const kitchenCabinetRef = useRef(null);
  // const wardrobeCabinetRef = useRef(null);

  useEffect(() => {
    if (cabinetType) {
      setSearchParams(prev => {
        const params = Object.fromEntries([...prev]);
        params['sub_type'] = cabinetType;
        return { ...params };
      });
    }
  }, [cabinetType]);

  // ===== EFFECT CŨ (CẬP NHẬT) =====
  useEffect(() => {
    if (!cabinetType) return; // Không khởi tạo scene nếu không có cabinetType

    // THAY ĐỔI: Sử dụng ExtendedSceneManager thay vì SceneManager
    const scene = new ExtendedSceneManager('canvas3d', undefined, () => {
      needUpdatePrice.current = true;
    });
    scene.initialize({ draggable: false, cabinetType });
    sceneRef.current = scene;
    insideLoaderRef.current = new InsideLoader(scene);

    //Xác định loại cabinet cho insideLoader
    insideLoaderRef.current.setCabinetType(cabinetType);

    setSceneManager(scene);

    if (auth.accessToken) {
      // dispatch(fetchPricePermanents()).then(action => {
      //   if (action.payload?.data) {
      //     const { data } = action.payload;
      //     scene.updatePrice(data);
      //   }
      // });
      // dispatch(fetchDefaultPriceConfig({ country_code }))
      //   .then(action => {
      //     if (action.payload?.data) {
      //       const { data } = action.payload;
      //       const priceConfig = data.price;
      //       const profitConfig = data.profit;
      //       const ruleConfig = data.rule;
      //       scene.updateDefaultViPriceConfig({
      //         priceConfig,
      //         profitConfig,
      //         ruleConfig,
      //       });
      //     }
      //   })
      //   .catch(e => {
      //     openMessageError({
      //       content: t('Unable to load default calculation configurations'),
      //     });
      //   });
    }

    const tex = FLOOR_TEXTURES.find(t => t.id === appearance.floorTexId);
    scene.updateWallColor(appearance.wallColor);
    if (tex)
      scene.updateFloorTextureFromImage(tex.img, {
        repeatBy: appearance.floorRepeat,
      });

    return () => {
      scene.dispose?.();
    };
  }, [cabinetType]);

  const handleExport = useCallback(
    customSceneManager => {
      const activeSceneManager = customSceneManager || sceneManager;

      const result = activeSceneManager?.getResultEstimatePrice?.();
      if (result?.registryCost) {
        const wb = convertCostDataToExcel(result.registryCost);
        if (wb) exportToExcel(wb, nameDesign ?? '');
      }
      // const data = result?.flat()?.map(item => ({
      //   ...item,
      //   formular: JSON.stringify(item.formular),
      // }));
      // console.log(data);
    },
    [sceneManager, nameDesign]
  );

  const buildEditLibraryData = (designData, data, cabinetType) => {
    const isKitchen = cabinetType === 'kitchen';

    return {
      _id: designData?.id, // tuỳ api
      name: designData?.name || '',
      code: designData?.code || designData?.description || '',

      dimensions: isKitchen
        ? {
            base: designData?.sizes?.base ?? designData?.base ?? 0,
            upper: designData?.sizes?.upper ?? designData?.upper ?? 0,
            fullHeight:
              designData?.sizes?.fullHeight ?? designData?.fullHeight ?? 0,
            countertop:
              designData?.sizes?.countertop ?? data?.countertop?.length ?? 0,
            backsplash:
              designData?.sizes?.backsplash ?? data?.backsplash?.length ?? 0,
            ledDecor:
              designData?.sizes?.ledDecor ?? data?.ledDecor?.length ?? 0,
          }
        : {
            length: designData?.sizes?.length ?? 0,
            depth: designData?.sizes?.depth ?? 0,
            height: designData?.sizes?.height ?? 0,
          },

      nonRecurringPrice: designData?.price_no_install ?? 0,
      depositPriceVN: designData?.price_with_install ?? 0,
      depositPriceUS: designData?.usd_price_with_install ?? 0,

      // ảnh: bạn map theo field thật của backend (ví dụ representative_image / images / thumbnail)
      representativeImageUrl: designData?.thumbnail_url || null,

      productImageUrls: designData?.image_urls || [],
    };
  };

  const fetchDesignLibraryDetail = async designId => {
    try {
      setIsLoadingDesign(true);
      const res = await callApi({
        endpoint: `sale_products/v3/detail/${designId}`,
        method: 'GET',
      });

      const designData = res?.data?.result?.data || res?.data;
      setNameDesign(designData.name);
      setCbTrim(designData.cabinet_trim);
      setDesignId(designId);
      if (sceneRef.current) {
        sceneRef.current.skipSpecialTexture =
          designData.skip_special_texture ?? false; // truyền thông số skip_special_texture vào scene manager để quyết định có áp dụng texture đặc biệt hay không khi tính giá
      }
      let data = designData?.data || '{}';

      if (designData?.price_info) {
        const jsonPriceInfo = JSON.parse(designData.price_info);
        if (jsonPriceInfo.costPersistable || jsonPriceInfo.salePersistable) {
          sceneRef.current?.importPersistableData(
            jsonPriceInfo.costPersistable,
            jsonPriceInfo.salePersistable
          );
        }
      }

      // 1) Khôi phục scene nền (tường/sàn) + appearance
      // if (data.scene?.export && sceneRef.current?.importSceneData) {
      //   sceneRef.current.importSceneData(data.scene.export);
      // }

      // setSelectedRoomId(designData.room_id || null);

      const objectToMap = o =>
        o && typeof o === 'object' ? new Map(Object.entries(o)) : new Map();

      // if (
      //   data.scene?.export?.wallTexture &&
      //   data.scene?.export?.floorTexture &&
      //   data.scene?.export?.floorSize
      // ) {
      //   const foundTex = FLOOR_TEXTURES.find(
      //     t => t.img === data.scene?.export?.floorTexture
      //   );

      //   // 2) Tính repeat theo kích thước sàn
      //   const repeatBy = calcFloorRepeat(
      //     data.floorSize?.width,
      //     data.floorSize?.depth
      //   );

      //   const newAppearance = {
      //     wallColor: data.scene?.export?.wallTexture || '#C8C8C8',
      //     floorTexId: foundTex ? foundTex.id : null,
      //     floorRepeat: repeatBy,
      //   };

      //   setAppearance(newAppearance);
      // }

      const currentFloorBounds = sceneRef.current?.getFloorBounds?.();
      const currentFloorMin = currentFloorBounds
        ? currentFloorBounds.min
        : { x: 0, y: 0, z: 0 };

      // 2) Khởi tạo cabinet
      if (!sceneManager) {
        openMessageWarning({ content: t('SceneManager is not ready!') });
        return data;
      }

      startCabinetDesign(data.cabinet?.cabinetType || cabinetType);

      // 3) Load lại modules từ API và tái dựng
      for (const m of data.modules || []) {
        try {
          // ===== FETCH MODULE DATA TỪ API (GIỐNG CARDPRODUCT) =====
          const action = await dispatch(fetchModule(m.moduleId));

          if (!action?.payload?.data) {
            // openMessageError({
            //   content: `Không thể load module ${m.moduleId}`,
            // });
            continue;
          }

          let moduleData = action.payload.data;

          moduleData = {
            ...moduleData,
            settings: { dimensions: m.dimensions, options: m.options },
          };

          if (m.beveled !== undefined) {
            moduleData.beveled = m.beveled;
          }

          // ===== LOAD MODULE VÀO SCENE =====
          const moduleInstance = await sceneManager.loadCabinetModule(
            moduleData,
            m.moduleType
          );

          moduleInstance.textures = objectToMap(m.textures);

          if (!moduleInstance?.group) {
            console.warn(`Không thể tạo instance cho module ${m.moduleId}`);
            continue;
          }

          // ===== SET TRS CHO GROUP =====
          const g = moduleInstance.group;
          // Khôi phục id bền để DIM tìm lại được module sau khi load
          if (m.userData?.instanceId) {
            g.userData.instanceId = m.userData.instanceId;
          }
          if (m.offsetFromFloor) {
            const newWorldPosition = {
              x: currentFloorMin.x + m.offsetFromFloor.x,
              y: currentFloorMin.y + m.offsetFromFloor.y,
              z: currentFloorMin.z + m.offsetFromFloor.z,
            };

            g.position.set(
              newWorldPosition.x,
              newWorldPosition.y,
              newWorldPosition.z
            );
          } else {
            const [px, py, pz] = m.groupTRS.p;
            g.position.set(px, py, pz);
          }
          const [rx, ry, rz] = m.groupTRS.r;
          g.rotation.set(rx, ry, rz);
          // g.scale.set(sx, sy, sz);
          g.updateMatrixWorld(true);

          // ===== THÊM VÀO POSITION CONTROLLER (GIỐNG ADDCABINETMODULE) =====
          if (sceneManager.positionController) {
            const clonedScene = g.clone();
            clonedScene.children = [
              clonedScene.children?.find(x => x.type === 'Group'),
            ];
            clonedScene.rotation.set(0, 0, 0);
            clonedScene.updateMatrixWorld(true);

            const box = new THREE.Box3().setFromObject(clonedScene);
            const size = new THREE.Vector3();
            box.getSize(size);
            const center = new THREE.Vector3();
            box.getCenter(center);

            sceneManager.positionController.addModule({
              id: g.uuid,
              x: center.x,
              y: center.y - size.y / 2,
              z: center.z,
              width: size.x,
              height: size.y,
              depth: size.z,
              rotate: g.rotation,
              group: moduleInstance.group,
            });
          }

          const currentCabinet =
            sceneManager.cabinetManager.getCurrentCabinet();

          // Load từng inside item
          const payload = m.inside;
          if (m.inside) {
            await applyInsideToModule({
              payload,
              moduleInstance,
              currentCabinet,
              insideLoader: insideLoaderRef.current,
            });
            await sceneManager.textureController.reloadTexture({
              module: moduleInstance,
            });
          }

          // ===== CẬP NHẬT LIST MODULE =====
          setListModule(prev => [...prev, moduleInstance]);
        } catch (error) {
          console.error(`Lỗi khi load module ${m.moduleId}:`, error);
          // openMessageError({ content: `Không thể tải module ${m.moduleId}` });
        }
      }

      // ===== TỰ ĐỘNG FIT CEILING (NẾU CÓ UPPER) =====
      // if (data.modules?.some((m) => m.moduleType?.includes("upper"))) {
      //   openModalFitHeight({
      //     func: () => {
      //       sceneManager.autoFitModuleController?.moveCeilingFollowHeightestUpperCabinet(
      //         { insideLoaderRef }
      //       );
      //     },
      //   });
      // }

      // 4) Khôi phục camera
      // Khôi phục DIM sau khi module đã load (anchor tìm theo instanceId)
      dispatch(setDimensions(parseDimensions(data.dimensions)));
      dispatch(setDimensionViews(parseViews(data.dimensionViews)));

      if (data.scene?.camera && sceneRef.current?.controls) {
        const c = data.scene.camera;
        if (c.position) {
          const [x, y, z] = c.position;
          sceneRef.current.camera.position.set(x, y, z);
        }
        if (c.target) {
          const [tx, ty, tz] = c.target;
          sceneRef.current.controls.target.set(tx, ty, tz);
        }
        sceneRef.current.camera.updateProjectionMatrix?.();
        sceneRef.current.render?.();
      }

      sceneManager.countertop = data.countertop || null;
      sceneManager.backsplash = data.backsplash || null;
      sceneManager.ledDecor = data.ledDecor || null;
      await sceneRef.current.updateAllCountertopAndBacksplash();
      openMessageSuccess({ content: t('Design reloaded!') });
      const editData = buildEditLibraryData(designData, data, cabinetType);

      setEditLibraryData(editData);
      sceneRef.current.handleDrawBorder();
      return data;
    } catch (error) {
      setIsLoadingDesign(false);
      console.error('Error fetching design:', error);
      // openMessageError({ content: "Không thể tải thiết kế" });
    } finally {
      setIsLoadingDesign(false);
      setIsDesignLibrary(true);
      // ===== TÍNH TOÁN TỔNG CHI PHÍ =====
      setTimeout(async () => {
        await sceneManager?.calculateTotalCost?.({});
      }, 300);
    }
  };

  const fetchDesignDetail = async designId => {
    try {
      setIsLoadingDesign(true);
      const res = await callApi({
        endpoint: `rooms/v3/rooms/design/${designId}`,
        method: 'GET',
      });

      const designData = res?.data?.result?.data || res?.data;
      setNameDesign(designData.name);
      setCbTrim(designData.cabinet_trim);
      setDesignId(designId);
      if (sceneRef.current) {
        sceneRef.current.skipSpecialTexture =
          designData.skip_special_texture ?? false; // truyền thông số skip_special_texture vào scene manager để quyết định có áp dụng texture đặc biệt hay không khi tính giá
      }

      if (designData?.price_info) {
        const jsonPriceInfo = JSON.parse(designData.price_info);
        if (jsonPriceInfo.costPersistable || jsonPriceInfo.salePersistable) {
          sceneRef.current?.importPersistableData(
            jsonPriceInfo.costPersistable,
            jsonPriceInfo.salePersistable
          );
        }
      }

      let data;
      try {
        data = JSON.parse(designData?.data || '{}');
      } catch (parseErr) {
        console.error('Failed to parse design data:', parseErr);
        openMessageWarning({ content: t('Design data is corrupted') });
        return;
      }

      // 1) Khôi phục scene nền (tường/sàn) + appearance
      if (data.scene?.export && sceneRef.current?.importSceneData) {
        sceneRef.current.importSceneData(data.scene.export);
      }

      setSelectedRoomId(designData.room_id || null);
      if (designData.room_id) {
        loadRoomFromServer(designData.room_id);
      }

      const objectToMap = o =>
        o && typeof o === 'object' ? new Map(Object.entries(o)) : new Map();

      if (
        data.scene?.export?.wallTexture &&
        data.scene?.export?.floorTexture &&
        data.scene?.export?.floorSize
      ) {
        const foundTex = FLOOR_TEXTURES.find(
          t => t.img === data.scene?.export?.floorTexture
        );

        // 2) Tính repeat theo kích thước sàn
        const repeatBy = calcFloorRepeat(
          data.floorSize?.width,
          data.floorSize?.depth
        );

        const newAppearance = {
          wallColor: data.scene?.export?.wallTexture || '#FCFCFC',
          floorTexId: foundTex ? foundTex.id : null,
          floorRepeat: repeatBy,
        };

        setAppearance(newAppearance);
      }

      // 2) Khởi tạo cabinet
      if (!sceneManager) {
        openMessageWarning({ content: t('SceneManager is not ready!') });
        return data;
      }

      startCabinetDesign(data.cabinet?.cabinetType || cabinetType);

      // 3) Load lại modules từ API và tái dựng
      for (const m of data.modules || []) {
        try {
          // ===== FETCH MODULE DATA TỪ API (GIỐNG CARDPRODUCT) =====
          const action = await dispatch(fetchModule(m.moduleId));

          if (!action?.payload?.data) {
            // openMessageError({
            //   content: `Không thể load module ${m.moduleId}`,
            // });
            continue;
          }

          let moduleData = action.payload.data;

          moduleData = {
            ...moduleData,
            settings: { dimensions: m.dimensions, options: m.options },
          };

          if (m.beveled !== undefined) {
            moduleData.beveled = m.beveled;
          }

          // ===== LOAD MODULE VÀO SCENE =====
          const moduleInstance = await sceneManager.loadCabinetModule(
            moduleData,
            m.moduleType
          );

          moduleInstance.textures = objectToMap(m.textures);

          if (!moduleInstance?.group) {
            console.warn(`Không thể tạo instance cho module ${m.moduleId}`);
            continue;
          }

          // ===== SET TRS CHO GROUP =====
          const g = moduleInstance.group;
          // Khôi phục id bền để DIM tìm lại được module sau khi load
          if (m.userData?.instanceId) {
            g.userData.instanceId = m.userData.instanceId;
          }
          const [px, py, pz] = m.groupTRS.p;
          const [rx, ry, rz] = m.groupTRS.r;
          // const [sx, sy, sz] = m.groupTRS.s;

          g.position.set(px, py, pz);
          g.rotation.set(rx, ry, rz);
          // g.scale.set(sx, sy, sz);
          g.updateMatrixWorld(true);

          // ===== THÊM VÀO POSITION CONTROLLER (GIỐNG ADDCABINETMODULE) =====
          if (sceneManager.positionController) {
            const clonedScene = g.clone();
            clonedScene.children = [
              clonedScene.children?.find(x => x.type === 'Group'),
            ];
            clonedScene.rotation.set(0, 0, 0);
            clonedScene.updateMatrixWorld(true);

            const box = new THREE.Box3().setFromObject(clonedScene);
            const size = new THREE.Vector3();
            box.getSize(size);
            const center = new THREE.Vector3();
            box.getCenter(center);

            sceneManager.positionController.addModule({
              id: g.uuid,
              x: center.x,
              y: center.y - size.y / 2,
              z: center.z,
              width: size.x,
              height: size.y,
              depth: size.z,
              rotate: g.rotation,
              group: moduleInstance.group,
            });
          }

          const currentCabinet =
            sceneManager.cabinetManager.getCurrentCabinet();

          // Load từng inside item
          const payload = m.inside;
          if (m.inside) {
            await applyInsideToModule({
              payload,
              moduleInstance,
              currentCabinet,
              insideLoader: insideLoaderRef.current,
            });
            await sceneManager.textureController.reloadTexture({
              module: moduleInstance,
            });
          }

          setTimeout(async () => {
            insideLoaderRef.current?.referenceManager.convertAllIdentifiersToUuids(
              moduleInstance
            );
            await sceneManager.calculateTotalCost?.({});
          }, 1000);

          // ===== CẬP NHẬT LIST MODULE =====
          setListModule(prev => [...prev, moduleInstance]);
        } catch (error) {
          console.error(`Lỗi khi load module ${m.moduleId}:`, error);
          // openMessageError({ content: `Không thể tải module ${m.moduleId}` });
        }
      }

      // ===== TỰ ĐỘNG FIT CEILING (NẾU CÓ UPPER) =====
      // if (data.modules?.some((m) => m.moduleType?.includes("upper"))) {
      //   openModalFitHeight({
      //     func: () => {
      //       sceneManager.autoFitModuleController?.moveCeilingFollowHeightestUpperCabinet(
      //         { insideLoaderRef }
      //       );
      //     },
      //   });
      // }

      // 4) Khôi phục camera
      // Khôi phục DIM sau khi module đã load (anchor tìm theo instanceId)
      dispatch(setDimensions(parseDimensions(data.dimensions)));
      dispatch(setDimensionViews(parseViews(data.dimensionViews)));

      if (data.scene?.camera && sceneRef.current?.controls) {
        const c = data.scene.camera;
        if (c.position) {
          const [x, y, z] = c.position;
          sceneRef.current.camera.position.set(x, y, z);
        }
        if (c.target) {
          const [tx, ty, tz] = c.target;
          sceneRef.current.controls.target.set(tx, ty, tz);
        }
        sceneRef.current.camera.updateProjectionMatrix?.();
        sceneRef.current.render?.();
      }

      sceneManager.countertop = data.countertop || null;
      sceneManager.backsplash = data.backsplash || null;
      sceneManager.ledDecor = data.ledDecor || null;
      await sceneRef.current.updateAllCountertopAndBacksplash();
      openMessageSuccess({
        content: t('Design reloaded!'),
        icon: <Icon.ICSuccess />,
      });

      // load nhà cung cấp
      let tempTextureFrame = null;
      let tempTextureDoor = null;
      let tempTextureLouveredWall = null;
      let tempTextileShoeLowerBench = null;
      const modules = sceneManager?.cabinetManager?.currentCabinet?.modules;
      if (modules) {
        const moduleEntries = Array.from(modules.entries());
        moduleEntries.forEach(([item, value]) => {
          if (value?.textures.get('frame')) {
            tempTextureFrame = value?.textures.get('frame');
          }
          if (value?.textures.get('DOOR')) {
            tempTextureDoor = value?.textures.get('DOOR');
          }
          if (
            value?.textures.get('VACH-LAM') ||
            value?.textures.get('VACH-TRON') ||
            value?.textures.get('VACH-GUONG')
          ) {
            tempTextureLouveredWall =
              value?.textures.get('VACH-LAM') ??
              value?.textures.get('VACH-TRON') ??
              value?.textures.get('VACH-GUONG');
          }
          if (value?.textures.get('shoe_lower_bench')) {
            tempTextileShoeLowerBench = value?.textures.get('shoe_lower_bench');
          }
          // tempCountertop = value?.countertop;
          // tempBacksplash = value?.backsplash;
        });
        dispatch(
          setCurrentSupplier({
            frame: {
              id:
                tempTextureFrame?.supplier?.id ??
                tempTextureDoor?.supplier?.id ??
                tempTextureLouveredWall?.supplier?.id,
              materialType:
                tempTextureFrame?.supplier?.materialType ??
                tempTextureDoor?.supplier?.materialType ??
                tempTextureLouveredWall?.supplier?.materialType,
              special:
                tempTextureFrame?.specialTexture ??
                tempTextureDoor?.specialTexture ??
                tempTextureLouveredWall?.specialTexture,
            },
            door: {
              id:
                tempTextureDoor?.supplier?.id ??
                tempTextureFrame?.supplier?.id ??
                tempTextureLouveredWall?.supplier?.id,
              materialType:
                tempTextureDoor?.supplier?.materialType ??
                tempTextureFrame?.supplier?.materialType ??
                tempTextureLouveredWall?.supplier?.materialType,
              special:
                tempTextureDoor?.specialTexture ??
                tempTextureFrame?.specialTexture ??
                tempTextureLouveredWall?.specialTexture,
            },
            louveredWall: {
              id:
                tempTextureLouveredWall?.supplier?.id ??
                tempTextureFrame?.supplier?.id ??
                tempTextureDoor?.supplier?.id,
              materialType:
                tempTextureLouveredWall?.supplier?.materialType ??
                tempTextureFrame?.supplier?.materialType ??
                tempTextureDoor?.supplier?.materialType,
              special:
                tempTextureLouveredWall?.specialTexture ??
                tempTextureFrame?.specialTexture ??
                tempTextureDoor?.specialTexture,
            },
            shoe_lower_bench: {
              id: tempTextileShoeLowerBench?.supplier?.id,
              materialType: tempTextileShoeLowerBench?.supplier?.materialType,
            },
            [ModuleType.COUNTERTOP]: sceneManager.countertop,
            [ModuleType.BACKSPLASH]: sceneManager.backsplash,
            [ModuleType.LED_DECOR]: sceneManager.ledDecor,
          })
        );
      }

      sceneRef.current.handleDrawBorder();
      return data;
    } catch (error) {
      setIsLoadingDesign(false);
      console.error('Error fetching design:', error);
      // openMessageError({ content: "Không thể tải thiết kế" });
    } finally {
      setIsLoadingDesign(false);
      // ===== TÍNH TOÁN TỔNG CHI PHÍ =====
      setTimeout(async () => {
        await sceneManager?.calculateTotalCost?.({});
      }, 3000);
    }
  };

  useEffect(() => {
    if (design_id && sceneManager) {
      fetchDesignDetail(design_id);
    }
  }, [design_id, sceneManager]);

  useEffect(() => {
    if (sale_product && sceneManager) {
      fetchDesignLibraryDetail(sale_product);
    }
  }, [sale_product, sceneManager]);

  // useEffect(() => {
  //   if (!design_id && !searchParams.get("room_id")) {
  //     setOpenRoomLibrary(true);
  //   }
  // }, [design_id, searchParams]);

  useEffect(() => {
    if (!sceneRef.current) return;
    const s = sceneRef.current;
    const tex = FLOOR_TEXTURES.find(t => t.id === appearance.floorTexId);
    s.updateWallColor(appearance.wallColor);
    if (tex)
      s.updateFloorTextureFromImage(tex.img, {
        repeatBy: appearance.floorRepeat,
      });
  }, [appearance]);

  // ===== EFFECT MỚI: TỰ ĐỘNG KHỞI TẠO CABINET DESIGN =====
  useEffect(() => {
    if (sceneManager && cabinetType) {
      // Luôn bắt đầu thiết kế cabinet (cabinetType đã được kiểm tra ở trên)
      startCabinetDesign(cabinetType);
      if (cabinetType === 'kitchen') {
        setSidebarKey({ active: true, key: 'kt1' });
      } else if (
        ['wardrobe', 'shoe', 'tv'].some(item => cabinetType.includes(item))
      ) {
        setSidebarKey({ active: true, key: 'wr1' });
      }
    }
  }, [sceneManager, cabinetType]);

  useEffect(() => {
    if (!design_id) {
      setOpenRoomLibrary(true);
    }
  }, [design_id]);

  // ===== EFFECTS CŨ (GIỮ NGUYÊN) =====
  useEffect(() => {
    if (
      sidebarKey?.active &&
      sidebarKey?.key === 'wallSetupForm' &&
      sceneRef.current
    ) {
      const data = sceneRef.current.exportSceneData();
      setSceneData(data);
    }
  }, [sidebarKey]);

  useEffect(() => {
    if (!sceneManager) return;
    if (selectedModel !== null) {
      const originalModule = sceneManager.cabinetManager.getModuleByGltfUuid(
        selectedModel?.uuid
      );
      if (originalModule) {
        setMdSelectedModelData(prevData => ({
          ...prevData,
          moduleType: originalModule.group.userData.moduleType,
          fitCeiling: originalModule.fitCeiling,
          mdDimensions: {
            // ...prevData.mdDimensions,
            ...originalModule?.formularController?.currentDimensions,
          },
          mdOptions: {
            // ...prevData.mdOptions,
            ...originalModule?.formularController?.currentOptions,
          },
          mdLimitedDimensions: {
            // ...prevData.mdLimitedDimensions,
            ...originalModule?.moduleData?.limit,
          },
          type: null,
        }));
      } else {
        const box = new THREE.Box3().setFromObject(selectedModel);
        const size = box.getSize(new THREE.Vector3());
        let height = sceneManager?.backsplash?.dimension?.height ?? size.y;
        let depth = Math.min(size.x, size.z);
        let length = 0;

        if (selectedModel?.userData?.type === ModuleType.BACKSPLASH) {
          selectedModels.forEach(model => {
            const box = new THREE.Box3().setFromObject(model);
            const size = box.getSize(new THREE.Vector3());
            length += Math.max(size.x, size.z);
          });
          setMdSelectedModelData(prevData => ({
            ...prevData,
            type: selectedModel?.userData?.type,
            mdDimensions: {
              height,
              width: length,
              depth,
            },

            mdOptions: {},
            mdLimitedDimensions: {},
          }));
        } else if (selectedModel?.userData?.type === ModuleType.COUNTERTOP) {
          let length = 0;
          let depth = 0;
          selectedModels.forEach(model => {
            const box = new THREE.Box3().setFromObject(model);
            const size = box.getSize(new THREE.Vector3());

            const countertopDepth = model.userData.countertopDepth;

            if (countertopDepth !== undefined) {
              if (
                nearlyEqual(roundTo(size.x, 3), countertopDepth + 0.03) ||
                nearlyEqual(roundTo(size.x, 3), countertopDepth)
              ) {
                length += size.z;
                depth = size.x;
              } else {
                length += size.x;
                depth = size.z;
              }
            } else {
              const orientation =
                model.userData.orientation ??
                GeometryUtils.getModuleOrientation(model);
              if (['ROTATED_270', 'ROTATED_90'].includes(orientation)) {
                length += size.x;
                depth = size.z;
              } else {
                length += size.z;
                depth = size.x;
              }
            }
          });

          setMdSelectedModelData(prevData => ({
            ...prevData,
            type: selectedModel?.userData?.type,
            mdDimensions: {
              height: size.y,
              width: length,
              depth: depth,
            },

            mdOptions: {},
            mdLimitedDimensions: {},
          }));
        }
      }
    }
  }, [selectedModel, sceneManager]);

  useEffect(() => {
    if (
      (selectedModel === null || selectedModels.length === 0) &&
      !meshClickRef.current
    ) {
      setNavbarKey();
      setOpenRightDoorAccessoryDesignMenu();
    }
    if (selectedModels.length) {
      sceneRef.current.removeBorderSelectedModule();

      setTimeout(() => {
        selectedModels.forEach(group =>
          sceneRef.current.handleDrawBorderSelectedModule(group)
        );
      }, 100);
    } else {
      sceneRef.current.removeBorderSelectedModule();
    }
  }, [selectedModel, selectedModels, meshClickRef, showMoveButton]);

  // ========= SNAP RECOMMEND HELPERS =========

  // Tìm module chứa intersection point
  const findModuleAtPoint = (intersectionPoint, currentCabinet) => {
    if (!intersectionPoint || !currentCabinet) return null;

    let targetModule = null;
    let minDistance = Infinity;

    currentCabinet.modules.forEach(module => {
      const box = new THREE.Box3().setFromObject(module.group);
      if (box.containsPoint(intersectionPoint)) {
        const center = new THREE.Vector3();
        box.getCenter(center);
        const distance = intersectionPoint.distanceTo(center);

        if (distance < minDistance) {
          minDistance = distance;
          targetModule = module;
        }
      }
    });

    return targetModule;
  };

  // Tìm 2 cạnh gần nhất theo trục Z (dọc) - HỖ TRỢ NHIỀU ORIENTATION
  const findClosestZEdges = (
    intersectionPoint,
    currentCabinet,
    targetModule
  ) => {
    if (!intersectionPoint || !currentCabinet || !targetModule) return null;

    const meshPoints = currentCabinet.getActiveMeshPoints(targetModule);
    if (!meshPoints || meshPoints.length === 0) return null;

    const orientation = GeometryUtils.getModuleOrientation(targetModule.group);

    // Sử dụng EdgeDetector tương ứng với orientation
    if (orientation === 'NORMAL' || orientation === 'ROTATED_180') {
      return EdgeDetector.findClosestZEdges(
        undefined,
        meshPoints,
        intersectionPoint,
        [InsideType.COL_PANEL]
      );
    } else if (orientation === 'ROTATED_90' || orientation === 'ROTATED_270') {
      return EdgeDetector.findClosestZEdgesR270(
        undefined,
        meshPoints,
        intersectionPoint,
        [InsideType.COL_PANEL]
      );
    }

    return null;
  };

  // Tìm 2 cạnh gần nhất theo trục Y (ngang) - HỖ TRỢ NHIỀU ORIENTATION
  const findClosestYEdges = (
    intersectionPoint,
    currentCabinet,
    targetModule
  ) => {
    if (!intersectionPoint || !currentCabinet || !targetModule) return null;

    const meshPoints = currentCabinet.getActiveMeshPoints(targetModule);
    if (!meshPoints || meshPoints.length === 0) return null;

    const orientation = GeometryUtils.getModuleOrientation(targetModule.group);

    if (orientation === 'NORMAL' || orientation === 'ROTATED_180') {
      return EdgeDetector.findClosestYEdges(
        undefined,
        meshPoints,
        intersectionPoint,
        null,
        undefined,
        true
      );
    } else if (orientation === 'ROTATED_90' || orientation === 'ROTATED_270') {
      return EdgeDetector.findClosestYEdgesR270(
        undefined,
        meshPoints,
        intersectionPoint,
        null,
        undefined,
        true
      );
    }

    return null;
  };

  // Tính trung điểm cho type 1 (dọc - theo Z/X tùy orientation)
  const calculateCenterPointVertical = (
    leftEdge,
    rightEdge,
    targetModule,
    intersectionPoint
  ) => {
    if (!leftEdge || !rightEdge || !targetModule) return null;

    const leftWorldPos = leftEdge.mesh.getWorldPosition(new THREE.Vector3());
    const rightWorldPos = rightEdge.mesh.getWorldPosition(new THREE.Vector3());

    const orientation = GeometryUtils.getModuleOrientation(targetModule.group);

    if (orientation === 'NORMAL' || orientation === 'ROTATED_180') {
      // Trung điểm theo Z
      const centerZ = (leftWorldPos.z + rightWorldPos.z) / 2;
      return new THREE.Vector3(
        intersectionPoint.x,
        intersectionPoint.y,
        centerZ
      );
    } else if (orientation === 'ROTATED_90' || orientation === 'ROTATED_270') {
      // Trung điểm theo X
      const centerX = (leftWorldPos.x + rightWorldPos.x) / 2;
      return new THREE.Vector3(
        centerX,
        intersectionPoint.y,
        intersectionPoint.z
      );
    }

    return null;
  };

  // Tính trung điểm cho type 0 (ngang - theo Y)
  const calculateCenterPointHorizontal = (
    bottomEdge,
    topEdge,
    targetModule,
    intersectionPoint
  ) => {
    if (!bottomEdge || !topEdge || !targetModule) return null;

    const bottomWorldPos = bottomEdge.mesh.getWorldPosition(
      new THREE.Vector3()
    );
    const topWorldPos = topEdge.mesh.getWorldPosition(new THREE.Vector3());

    // Tính trung điểm theo Y (chiều cao) - không phụ thuộc orientation
    const centerY = (bottomWorldPos.y + topWorldPos.y) / 2;

    return new THREE.Vector3(intersectionPoint.x, centerY, intersectionPoint.z);
  };

  // Kiểm tra gần trung điểm
  const isNearCenterPoint = (
    point,
    centerPoint,
    previewType,
    targetModule,
    threshold = SNAP_THRESHOLD
  ) => {
    if (!point || !centerPoint || !targetModule) return false;

    const orientation = GeometryUtils.getModuleOrientation(targetModule.group);

    // Type 1: Snap theo chiều dọc (Z hoặc X tùy orientation)
    if (previewType === 1) {
      if (orientation === 'NORMAL' || orientation === 'ROTATED_180') {
        return Math.abs(point.z - centerPoint.z) < threshold;
      } else if (
        orientation === 'ROTATED_90' ||
        orientation === 'ROTATED_270'
      ) {
        return Math.abs(point.x - centerPoint.x) < threshold;
      }
    }

    // Type 0: Snap theo chiều ngang (Y) - không phụ thuộc orientation
    if (previewType === 0) {
      return Math.abs(point.y - centerPoint.y) < threshold;
    }

    return false;
  };

  // Tạo/cập nhật snap line
  const createOrUpdateSnapLine = (
    centerPoint,
    targetModule,
    previewType,
    isNear = false
  ) => {
    if (!sceneRef.current || !centerPoint || !targetModule) {
      hideSnapLine();
      return;
    }

    // Tạo line lần đầu
    if (!snapLineRef.current) {
      const material = new THREE.LineDashedMaterial({
        color: 0x1e90ff,
        dashSize: 0.1,
        gapSize: 0.05,
        linewidth: 2,
        transparent: true,
        opacity: 0.8,
        depthTest: false,
      });

      const geometry = new THREE.BufferGeometry();
      snapLineRef.current = new THREE.Line(geometry, material);
      snapLineRef.current.renderOrder = 1000;
      sceneRef.current.scene.add(snapLineRef.current);
    }

    const moduleBox = new THREE.Box3().setFromObject(targetModule.group);
    const orientation = GeometryUtils.getModuleOrientation(targetModule.group);

    let startPoint, endPoint;

    // Type 1: Line dọc (theo trục Y)
    if (previewType === 1) {
      startPoint = new THREE.Vector3(
        centerPoint.x,
        moduleBox.min.y - 0.05,
        centerPoint.z
      );

      endPoint = new THREE.Vector3(
        centerPoint.x,
        moduleBox.max.y + 0.05,
        centerPoint.z
      );
    }
    // Type 0: Line ngang (theo trục Z hoặc X tùy orientation)
    else if (previewType === 0) {
      if (orientation === 'NORMAL' || orientation === 'ROTATED_180') {
        // Line chạy dọc theo Z (ngang khi nhìn)
        startPoint = new THREE.Vector3(
          centerPoint.x,
          centerPoint.y,
          moduleBox.min.z - 0.05
        );

        endPoint = new THREE.Vector3(
          centerPoint.x,
          centerPoint.y,
          moduleBox.max.z + 0.05
        );
      } else if (
        orientation === 'ROTATED_90' ||
        orientation === 'ROTATED_270'
      ) {
        // Line chạy dọc theo X (ngang khi nhìn)
        startPoint = new THREE.Vector3(
          moduleBox.min.x - 0.05,
          centerPoint.y,
          centerPoint.z
        );

        endPoint = new THREE.Vector3(
          moduleBox.max.x + 0.05,
          centerPoint.y,
          centerPoint.z
        );
      }
    }

    // Cập nhật geometry
    const positions = new Float32Array([
      startPoint.x,
      startPoint.y,
      startPoint.z,
      endPoint.x,
      endPoint.y,
      endPoint.z,
    ]);

    snapLineRef.current.geometry.setAttribute(
      'position',
      new THREE.BufferAttribute(positions, 3)
    );

    snapLineRef.current.computeLineDistances();

    // Thay đổi màu khi snap
    if (isNear) {
      snapLineRef.current.material.color.setHex(0x00ff00);
      snapLineRef.current.material.opacity = 1.0;
      snapLineRef.current.material.dashSize = 0.15;
      snapLineRef.current.material.gapSize = 0.08;
    } else {
      snapLineRef.current.material.color.setHex(0x1e90ff);
      snapLineRef.current.material.opacity = 0.8;
      snapLineRef.current.material.dashSize = 0.1;
      snapLineRef.current.material.gapSize = 0.05;
    }

    snapLineRef.current.visible = true;
  };

  // Ẩn snap line
  const hideSnapLine = () => {
    if (snapLineRef.current) {
      snapLineRef.current.visible = false;
    }
    centerPointRef.current = null;
  };

  const handleSaveModuleEdit = async updatedData => {
    try {
      if (!editingModule || !sceneManager) return;

      // Cập nhật dữ liệu module trong scene
      if (editingModule.userData && editingModule.userData.moduleData) {
        // Merge dữ liệu mới vào moduleData hiện tại
        editingModule.userData.moduleData = {
          ...editingModule.userData.moduleData,
          ...updatedData,
        };

        // Nếu có thay đổi kích thước, cập nhật geometry
        if (updatedData.width || updatedData.height || updatedData.depth) {
          const cabinet = sceneManager.getCurrentCabinet();
          if (cabinet && cabinet.updateModuleGeometry) {
            await cabinet.updateModuleGeometry(editingModule, updatedData);
          }
        }

        // Nếu có thay đổi material, cập nhật material
        if (updatedData.material || updatedData.texture) {
          const cabinet = sceneManager.getCurrentCabinet();
          if (cabinet && cabinet.updateModuleMaterial) {
            await cabinet.updateModuleMaterial(editingModule, updatedData);
          }
        }

        // Cập nhật position controller nếu có thay đổi kích thước
        if (
          sceneManager.positionController &&
          (updatedData.width || updatedData.height || updatedData.depth)
        ) {
          const box = new THREE.Box3().setFromObject(editingModule.group);
          const size = new THREE.Vector3();
          box.getSize(size);
          sceneManager.positionController.updateModule(editingModule.uuid, {
            width: size.x,
            height: size.y,
            depth: size.z,
          });
        }

        // Render lại scene
        sceneManager.render();
      }

      // Đóng form
      setShowEditForm(false);
      setEditingModule(null);
    } catch (error) {
      console.error('Error updating module:', error);
      // Có thể thêm thông báo lỗi cho user
    }
  };

  const handleApplyWallSettings = ({
    sceneData,
    appearance: newAppearance,
    roomId,
    isUpdate,
    savedRoom,
    customerChanged,
  }) => {
    // Đổi khách của room đang mở thì giá áp dụng có thể đổi (khách đã chốt dùng giá chốt). Room mới tạo đã được
    // useRoomPriceContext xử lý khi selectedRoomId đổi
    if (customerChanged && isUpdate) refreshRoomPriceData(dispatch);
    if (sceneRef.current && sceneData) {
      sceneRef.current.importSceneData(sceneData);
    }
    if (newAppearance) setAppearance(newAppearance);

    if (roomId && !isUpdate) {
      setSelectedRoomId(roomId);
    }

    // Giữ bản ghi room khớp với những gì vừa lưu (kể cả room mới tạo, chưa từng được tải) để lần mở form sau điền
    // đủ tên, kích thước, khách
    if (savedRoom) {
      setCurrentRoomData(prev => ({ ...prev, ...savedRoom }));
    }

    setSidebarKey(prev => ({ ...prev, active: false }));
  };

  // loadModule - CHỈ hỗ trợ addCabinetModule vì đây là cabinet designer
  const loadModule = async (moduleData, position) => {
    console.warn(
      `DesignerPage is a cabinet designer for ${cabinetType}. Use addCabinetModule instead of loadModule.`
    );
    return null;
  };

  const removeModule = async moduleToRemove => {
    if (!sceneManager || !moduleToRemove) return;

    // SỬA: Sử dụng ExtendedSceneManager method
    sceneManager.removeCabinetModule(moduleToRemove);

    // Remove from list
    setListModule(prev =>
      prev.filter(module => module.uuid !== moduleToRemove.uuid)
    );

    // Clear selection if this was the selected module
    if (selectedModel?.uuid === moduleToRemove.uuid) {
      sceneManager.clearSelection?.();
    }

    //update lại MB,VB nếu có
    await sceneRef.current.updateAllCountertopAndBacksplash();

    setTimeout(async () => {
      await sceneManager?.calculateTotalCost?.({});
    }, 300);
  };

  const clearAllModules = () => {
    if (!sceneManager) return;

    // SỬA: Sử dụng ExtendedSceneManager method
    sceneManager.clearAllCabinets();

    // Clear list and selection
    setListModule([]);
    if (sceneManager.clearSelection) {
      sceneManager.clearSelection();
    }
  };

  // ===== FUNCTIONS MỚI CHO CABINET (SỬA ĐỂ SỬ DỤNG CABINETMANAGER) =====
  const startCabinetDesign = cabinetType => {
    if (!sceneManager) return;

    try {
      // SỬA: Sử dụng ExtendedSceneManager method thay vì tạo instance riêng
      const cabinet = sceneManager.startCabinetDesign(cabinetType);

      setCurrentCabinetType(cabinetType);
      setCurrentCabinet(cabinet);

      // Set available module types
      const constraints = sceneManager.getCabinetConstraints(cabinetType);
      constraints?.typePriorities &&
        setAvailableModuleTypes(Object.keys(constraints?.typePriorities));
    } catch (error) {
      console.error(' Error starting cabinet design:', error);
    }
  };

  const boxExcludingMeshes = (group, excludeNames = ['MAT-DA', 'VACH-BEP']) => {
    const box = new THREE.Box3().makeEmpty();
    group.updateWorldMatrix(true, true);

    group.traverse(obj => {
      if (!obj.isMesh || !obj.geometry) return;

      const n = (obj.name || '').toUpperCase();
      // bỏ nếu tên trùng/bao gồm
      if (excludeNames.some(ex => n.includes(ex))) return;

      if (!obj.geometry.boundingBox) obj.geometry.computeBoundingBox();
      const gbox = obj.geometry.boundingBox
        .clone()
        .applyMatrix4(obj.matrixWorld);
      box.union(gbox);
    });

    return box;
  };

  // SỬA: Sử dụng ExtendedSceneManager method
  const addCabinetModule = async (moduleData, moduleType) => {
    try {
      if (!currentCabinetType) {
        throw new Error('No cabinet type selected');
      }

      if (!sceneManager) {
        throw new Error('SceneManager not available');
      }
      // if (cabinetType === "kitchen") {
      // console.log(sceneManager.cabinetManager.currentCabinet.modules)

      let y = moduleType.includes('lower')
        ? 0
        : ['tv'].some(item => moduleType.includes(item))
          ? 0.4
          : ['bed'].some(item => moduleType.includes(item))
            ? 0.3
            : 0.79; // Bắt đầu từ 0 cho lower, 0.85 cho upper/ceiling
      const { wallHeight } = sceneManager;
      const heightModule = moduleData.default.height;
      const modules = Array.from(
        sceneManager.cabinetManager.currentCabinet.modules
      );
      const modulesUpper = modules.filter(([key, module]) =>
        module.moduleType.includes('upper')
      );

      modules.forEach(([key, module]) => {
        if (moduleType.includes('upper')) {
          if (
            module.cabinetType.includes('lower') &&
            !module.cabinetType.includes('totl') &&
            !module.cabinetType.includes('dry') &&
            !module.cabinetType.includes('corner')
          ) {
            // const model = GeometryUtils.moduleWithoutAccessory(module.group);
            // const box = boxExcludingMeshes(model);
            // const size = new THREE.Vector3();
            // box.getSize(size);
            // y = size.y;
            const height = module.formularController?.currentDimensions?.height;
            if (y < height) {
              y = height;
            }
          }
        } else if (moduleType.includes('ceiling')) {
          if (
            ['wardrobe', 'shoe', 'tv', 'decorative'].some(item =>
              module.cabinetType.includes(item)
            )
          ) {
            if (module.cabinetType.includes('lower')) {
              const height =
                module.formularController?.currentDimensions?.height;
              if (y < height) {
                y = height;
              }
              // const model = GeometryUtils.moduleWithoutAccessory(module.group);
              // const box = new THREE.Box3().setFromObject(model);
              // const size = new THREE.Vector3();
              // box.getSize(size);
              // const center = new THREE.Vector3();
              // box.getCenter(center);
              // if (y < size.y / 2 + center.y) {
              //   y = size.y / 2 + center.y;
              // }
            }
          } else if (module.cabinetType.includes('kitchen')) {
            if (module.cabinetType.includes('upper')) {
              const model = GeometryUtils.moduleWithoutAccessory(module.group);
              const box = new THREE.Box3().setFromObject(model);
              const size = new THREE.Vector3();
              box.getSize(size);
              const center = new THREE.Vector3();
              box.getCenter(center);
              if (y < size.y / 2 + center.y) {
                y = size.y / 2 + center.y;
              }
            } else if (module.cabinetType.includes('lower')) {
              const height =
                module.formularController?.currentDimensions?.height;
              if (y < height) {
                y = height;
              }
            }
          }
        }
      });

      // Đặt vị trí của module dựa trên những module đã có
      if (
        (moduleType.includes('upper') &&
          ['kitchen'].some(item => cabinetType.includes(item))) ||
        (!modulesUpper.length &&
          moduleType.includes('ceiling') &&
          ['kitchen'].some(item => cabinetType.includes(item)))
      ) {
        y =
          y +
          (sceneManager?.backsplash?.dimension?.height ?? 0.6) +
          (sceneManager?.countertop?.dimension?.height ?? 0.02); // Thêm chiều cao vách
      }
      if (
        heightModule + y <= wallHeight * 1000 ||
        moduleType.includes('ceiling')
      ) {
        moduleData = {
          ...moduleData,
          settings: {
            dimensions: moduleData?.library_data?.dimensions,
            options: moduleData?.library_data?.options,
          },
        };
        moduleData = {
          ...moduleData,
          product_type: product_type,
        };
        // SỬA: Sử dụng ExtendedSceneManager method
        const moduleInstance = await sceneManager.loadCabinetModule(
          moduleData,
          moduleType,
          y
        );

        const { x, z } = moduleInstance.group.position;
        moduleInstance.group.position.set(x, y, z);
        moduleInstance.group.updateMatrixWorld(true);

        // Cập nhật danh sách modules (nếu cần thiết cho UI)
        setListModule(prev => [...prev, moduleInstance]);

        // // Cập nhật lại vị trí TĐT nếu có
        // if (moduleType.includes("upper")) {
        //   openModalFitHeight({
        //     func: () => {
        //       sceneManager.autoFitModuleController.moveUpperFollowHeightestLowerCabinet(
        //         { insideLoaderRef }
        //       );
        //       sceneManager.autoFitModuleController.moveCeilingFollowHeightestUpperCabinet(
        //         { insideLoaderRef }
        //       );
        //     },
        //   });
        // } else if (moduleType.includes("ceiling")) {
        //   openModalFitHeight({
        //     func: () => {
        //       sceneManager.autoFitModuleController.moveCeilingFollowHeightestUpperCabinet(
        //         { insideLoaderRef }
        //       );
        //     },
        //   });
        // }

        // Thêm module vào danh sách module của positionController (nếu có)
        if (sceneManager.positionController && moduleInstance.group) {
          const clonedScene = moduleInstance.group.clone();
          clonedScene.children = [
            clonedScene.children?.find(x => x.type === 'Group'),
          ];
          clonedScene.rotation.set(0, 0, 0);
          clonedScene.updateMatrixWorld(true);

          const box = new THREE.Box3().setFromObject(clonedScene);
          const size = new THREE.Vector3();
          box.getSize(size);
          const center = new THREE.Vector3();
          box.getCenter(center);

          sceneManager.positionController.addModule({
            id: moduleInstance.group.uuid,
            x: center.x,
            y: center.y - size.y / 2,
            z: center.z,
            width: size.x,
            height: size.y,
            depth: size.z,
            rotate: moduleInstance.group.rotation,
            group: moduleInstance.group,
          });
        }
        const payload = moduleInstance?.library_data?.inside;
        if (payload) {
          await applyInsideToModule({
            payload,
            moduleInstance,
            currentCabinet: sceneManager.cabinetManager.getCurrentCabinet(),
            insideLoader: insideLoaderRef.current,
          });
        }

        //update lại MB,VB nếu có
        await sceneRef.current.updateAllCountertopAndBacksplash();

        setTimeout(async () => {
          await sceneManager?.calculateTotalCost?.({});
        }, 300);

        return moduleInstance;
      }
      // }
    } catch (error) {
      console.error(' Error adding cabinet module:', error);
      throw error;
    }
  };

  //  XÓA: Không cần getCabinetInstance nữa vì đã có trong CabinetManager

  const finishCabinetDesign = () => {
    if (!sceneManager) return;

    // SỬA: Sử dụng ExtendedSceneManager method
    const finishedCabinet = sceneManager.finishCabinetDesign();

    setCurrentCabinetType(null);
    setCurrentCabinet(null);
    setAvailableModuleTypes([]);

    return finishedCabinet;
  };

  const handleSaveLibraryModule = async formDataSave => {
    try {
      setIsLoadingSave(true);
      let module = selectedModel;
      const model = findTopLevelParent(module);

      const clonedModule = currentCabinet.getModuleByGroupUuid(model.uuid);
      if (!clonedModule || !sceneRef.current) {
        openMessageWarning({ content: t('No module to save!') });
        return;
      }

      // 2) Lưu thông tin inside theo logic saveDesign
      const insidePayload =
        insideLoaderRef.current?.saveInsideDesignOfModule(clonedModule) || [];

      // 3) Thu thập metadata của module
      const libraryData = {
        // Kích thước và options
        dimensions: clonedModule.formularController?.currentDimensions || null,
        options: clonedModule.formularController?.currentOptions || null,

        // Vật liệu và màu sắc
        // material: clonedModule.material || null,
        // color: clonedModule.color || null,
        // doorType: clonedModule.doorType || null,
        // handleType: clonedModule.handleType || null,
        // beveled: clonedModule.beveled || clonedModule.cabinet?.beveled || null,

        // Inside design
        inside: insidePayload,
      };

      const formData = new FormData();
      formData.append('name', formDataSave?.name.trim());
      formData.append('parent_id', clonedModule.moduleData.id || '');
      formData.append(
        'category_id ',
        clonedModule.moduleData.category_id || ''
      );
      formData.append('library_data', JSON.stringify(libraryData));
      formData.append('thumbnail', formDataSave.thumbnailFile || null);

      const res = await callApi({
        endpoint: 'modules/v3/basemodules/library',
        method: 'post',
        data: formData,
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
      if (res?.data?.success === true) {
        openMessageSuccess({
          content: t('Saved module {{name}} to the library!', {
            name: formDataSave.name,
          }),
        });
      }
    } catch (error) {
      setIsLoadingSave(false);
      console.error('Lỗi khi lưu module vào thư viện:', error);
      openMessageError({ content: t('Failed to save module to library!') });
      throw error; // Throw để modal không đóng khi có lỗi
    } finally {
      setIsLoadingSave(false);
    }
  };

  // --- helpers ---
  const normKey = k => (k ? String(k).trim().toUpperCase() : '');
  const pickTextureFields = (t = {}) => ({
    textureId: t.textureId ?? t.textureID ?? t.id ?? null,
    textureCode: t.textureCode ?? null,
    supplier: t.supplier ?? null,
    paintColor: t.paintColor ?? null,
    texturePrice: t.texturePrice ?? null, // object {thickness: price} => giữ nguyên
    textureUrl: t.textureUrl ?? t.url ?? null,
  });

  // Tạo "dedupe key": ưu tiên textureId, fallback supplier+code
  const makeDedupeKey = t => {
    if (t.textureId) return `ID:${t.textureId}`;
    return `SC:${(t.supplier || '').toUpperCase()}|${(
      t.textureCode || ''
    ).toUpperCase()}`;
  };

  // Gom texture duy nhất từ modules (Map<id, module>)
  const collectUniqueTextures = modulesMap => {
    const frameSet = new Set();
    const doorSet = new Set();
    const louveredWallSet = new Set();
    const shoeLowerBenchSet = new Set();
    const frameList = [];
    const doorList = [];
    const louveredWallList = [];
    const shoeLowerBenchList = [];

    for (const [, module] of modulesMap) {
      const textures = module?.textures; // Map or plain object
      if (!textures) continue;

      // Chuẩn hoá về entries iterable
      const entries =
        textures instanceof Map
          ? Array.from(textures.entries()) // [key, value]
          : Object.entries(textures);

      for (const [k, v] of entries) {
        const key = normKey(k);
        const tex = pickTextureFields(v || {});
        const dKey = makeDedupeKey(tex);

        if (key === 'FRAME') {
          if (!frameSet.has(dKey)) {
            frameSet.add(dKey);
            frameList.push(tex);
          }
        } else if (key === 'DOOR') {
          if (!doorSet.has(dKey)) {
            doorSet.add(dKey);
            doorList.push(tex);
          }
        } else if (
          ['VACH-LAM', 'VACH-TRON', 'VACH-GUONG'].some(item => key === item)
        ) {
          if (!louveredWallSet.has(dKey)) {
            louveredWallSet.add(dKey);
            louveredWallList.push(tex);
          }
        } else if (['SHOE_LOWER_BENCH'].some(item => key === item)) {
          if (!shoeLowerBenchSet.has(dKey)) {
            shoeLowerBenchSet.add(dKey);
            shoeLowerBenchList.push(tex);
          }
        }
      }
    }

    return { frameList, doorList, louveredWallList, shoeLowerBenchList };
  };

  const makeBuckets = modulesMap => {
    const names = [
      ...new Set(
        [...modulesMap.values()]
          .map(m => m?.moduleData?.product_type_group_name?.trim())
          .filter(Boolean)
      ),
    ];
    return names.map(name => ({ key: name, value: [] }));
  };

  /**
   * Collect product type groups from cabinet modules, countertop, backsplash, and LED decor.
   * Shared helper used by testSaveLibrary, handleSaveLibraryDesign, and handleUpdateLibraryDesign.
   */
  const collectProductTypeGroups = (currentCabinet, sm) => {
    const productTypeGroupNames = Array.from(currentCabinet.modules).reduce(
      (acc, [, module]) => {
        const groupName = (
          module?.moduleData?.product_type_group_name || ''
        ).trim();

        if (groupName !== '') {
          if (!acc[groupName]) {
            acc[groupName] = [];
          }

          const textureFrame = module?.textures.get('frame');
          const textureDoor = module?.textures.get('DOOR');

          const addOrUpdateItem = itemData => {
            const existingItemIndex = acc[groupName].findIndex(
              item =>
                item.name === itemData.name &&
                item.material === itemData.material &&
                item.texture === itemData.texture &&
                item.textureId === itemData.textureId &&
                JSON.stringify(item.size) === JSON.stringify(itemData.size)
            );

            if (existingItemIndex !== -1) {
              acc[groupName][existingItemIndex].count += 1;
            } else {
              acc[groupName].push(itemData);
            }
          };

          addOrUpdateItem({
            name: module.moduleData.name,
            thumbnail_url: module.moduleData.thumbnail_url,
            size: GeometryUtils.getSizeRotation(module.group, module.group),
            material: textureFrame?.material,
            texture: textureFrame?.textureCode,
            textureUrl: textureFrame?.textureUrl,
            textureId: textureFrame?.textureId,
            count: 1,
          });

          module?.listInside.forEach(item => {
            if (
              item.type === InsideType.BRACE ||
              item.type === InsideType.COL_PANEL
            )
              return;

            if (!item.gltf || !module.group) return;

            if (item.type === InsideType.HANDLE) {
              addOrUpdateItem({
                name: item.name,
                thumbnail_url: item.thumbnail_url,
                size: null,
                material: null,
                texture: null,
                textureUrl: null,
                textureId: null,
                count: 1,
              });
              return;
            }

            if (
              item.type === InsideType.HPANEL ||
              item.type === InsideType.VPANEL ||
              item.type === InsideType.VPANEL2 ||
              item.type === InsideType.DRAWER ||
              item.type === InsideType.U_DRAWER
            ) {
              addOrUpdateItem({
                name: item.name,
                thumbnail_url: item.thumbnail_url,
                size: GeometryUtils.getSizeRotation(module.group, item.gltf),
                material: textureFrame?.material,
                texture: textureFrame?.textureCode,
                textureUrl: textureFrame?.textureUrl,
                textureId: textureFrame?.textureId,
                count: 1,
              });
            } else if (item.type === InsideType.DOOR) {
              addOrUpdateItem({
                name: item.name,
                thumbnail_url: item.thumbnail_url,
                size: GeometryUtils.getSizeRotation(module.group, item.gltf),
                material: textureDoor?.material,
                texture: textureDoor?.textureCode,
                textureUrl: textureDoor?.textureUrl,
                textureId: textureDoor?.textureId,
                count: 1,
              });
            } else {
              addOrUpdateItem({
                name: item.name,
                thumbnail_url: item.thumbnail_url,
                size: GeometryUtils.getSizeRotation(module.group, item.gltf),
                material: null,
                texture: null,
                textureUrl: null,
                textureId: null,
                count: 1,
              });
            }
          });
        }
        return acc;
      },
      {}
    );

    if (sm?.countertop?.using === true) {
      const countertopGroupName = 'Countertop';
      if (!productTypeGroupNames[countertopGroupName]) {
        productTypeGroupNames[countertopGroupName] = [];
      }
      const countertopTexture = sm.countertop?.texture;
      const countertopMaterial = sm.countertop?.material;
      productTypeGroupNames[countertopGroupName].push({
        name: 'Countertop',
        thumbnail_url: countertopTexture?.url || null,
        size: null,
        material: countertopMaterial?.material || null,
        texture: countertopTexture?.textureCode || null,
        textureUrl: countertopTexture?.url || null,
        textureId: countertopTexture?.textureId || null,
        count: 1,
      });
    }

    if (sm?.backsplash?.using === true) {
      const backsplashGroupName = 'Backsplash';
      if (!productTypeGroupNames[backsplashGroupName]) {
        productTypeGroupNames[backsplashGroupName] = [];
      }
      const backsplashTexture = sm.backsplash?.texture;
      const backsplashMaterial = sm.backsplash?.material;
      productTypeGroupNames[backsplashGroupName].push({
        name: 'Backsplash',
        thumbnail_url: backsplashTexture?.url || null,
        size: null,
        material: backsplashMaterial?.material || null,
        texture: backsplashTexture?.textureCode || null,
        textureUrl: backsplashTexture?.url || null,
        textureId: backsplashTexture?.textureId || null,
        count: 1,
      });
    }

    if (sm?.ledDecor?.using === true) {
      const ledDecorGroupName = 'LED Decor';
      if (!productTypeGroupNames[ledDecorGroupName]) {
        productTypeGroupNames[ledDecorGroupName] = [];
      }
      const ledDecorTexture = sm.ledDecor?.texture;
      const ledDecorMaterial = sm.ledDecor?.material;
      productTypeGroupNames[ledDecorGroupName].push({
        name: 'LED Decor',
        thumbnail_url: ledDecorTexture?.url || null,
        size: null,
        material: ledDecorMaterial?.material || null,
        texture: ledDecorTexture?.textureCode || null,
        textureUrl: ledDecorTexture?.url || null,
        textureId: ledDecorTexture?.textureId || null,
        count: 1,
      });
    }

    return productTypeGroupNames;
  };

  const testSaveLibrary = () => {
    const currentCabinet = sceneManager.cabinetManager.getCurrentCabinet();
    const result = sceneManager?.getResultEstimatePrice();
    const productTypeGroupNames = collectProductTypeGroups(
      currentCabinet,
      sceneManager
    );
  };

  /**
   * Tạo price_info của lần lưu hiện tại. Chỉ gửi 1 bản giá duy nhất; lịch sử tính giá
   * do backend lưu ở bảng riêng nên FE không nối/gửi priceHistory nữa.
   * Để giảm kích thước:
   * - Registry/persistable chỉ giữ theo country_code hiện tại (bỏ nhánh quốc gia còn lại).
   * - Không gửi dataExcel: trùng với costPersistable[country_code].registry.
   * - topModules chỉ giữ thông tin nhận diện/kích thước; phần chi tiết (inside, textures,
   *   userData, groupTRS...) đã nằm trong `data` của thiết kế.
   */
  const buildPriceInfo = (result, topModules) => {
    const byCountry = value =>
      value?.[country_code] !== undefined
        ? { [country_code]: value[country_code] }
        : value;

    return {
      savedAt: new Date().toISOString(),
      country_code,
      grand: result?.grand,
      grandCost: result?.grandCost,
      total: result?.total,
      topModules: (topModules || []).map(
        ({ moduleId, moduleType, dimensions, options }) => ({
          moduleId,
          moduleType,
          dimensions,
          options,
        })
      ),
      costPersistable: byCountry(result?.costPersistable),
      salePersistable: byCountry(result?.salePersistable),
    };
  };

  const handleSaveLibraryDesign = useCallback(
    async uiData => {
      try {
        setIsLoadingSave(true);
        if (!sceneRef.current || !sceneManager) {
          console.warn('SceneManager chưa sẵn sàng.');
          return;
        }

        const currentCabinet = sceneManager.cabinetManager.getCurrentCabinet();
        if (!currentCabinet) {
          console.warn('Chưa có cabinet hiện hành để lưu.');
          return;
        }

        let totalWoodPrice = 0;
        let totalAccessoryPrice = 0;
        let totalCountertopPrice = 0;
        let totalBacksplashPrice = 0;
        let metadata = null;

        const result = await sceneManager?.calculateTotalCost?.({
          isFinal: true,
        });
        // const dataExcel = sceneManager?.getEstimateExcelData?.();
        // if (result?.total?.total === 0) {
        //   openMessageWarning({
        //     content: 'Vui lòng chọn đầy đủ vật liệu và màu sắc trước khi lưu.',
        //   });
        //   return;
        // } else {
        const detailSaleTotals = result?.detailSaleTotals?.vn;
        const aggregatedSaleTotals = result?.aggregatedSaleTotals?.vn;

        totalWoodPrice = roundTo(
          aggregatedSaleTotals?.accessory +
            aggregatedSaleTotals?.component +
            aggregatedSaleTotals?.doors +
            aggregatedSaleTotals?.labor +
            aggregatedSaleTotals?.materials,
          0
        );
        totalAccessoryPrice =
          (detailSaleTotals?.special?.equipments?.total ?? 0) +
          (detailSaleTotals?.special?.curveBlocks ?? 0);
        totalCountertopPrice =
          detailSaleTotals?.special?.countertop?.total ?? 0;
        totalBacksplashPrice =
          detailSaleTotals?.special?.backsplash?.total ?? 0;

        metadata = {
          // price: {
          //   countRail: result?.countRail ?? 0,
          //   countHinge: result?.countHinge ?? 0,
          //   countConnector: result?.countConnector ?? 0,
          //   countertop: result?.countertop ?? 0,
          //   backsplash: result?.backsplash ?? 0,
          //   ledDecor: result?.ledDecor ?? 0,
          // },
        };
        // }

        // 1) Scene chung (tường/sàn/camera)
        const sceneExport = sceneRef.current.exportSceneData?.() || null;
        const camera = sceneRef.current.camera;
        const cameraState = camera
          ? {
              position: [
                camera.position.x,
                camera.position.y,
                camera.position.z,
              ],
              target: sceneRef.current.controls?.target
                ? [
                    sceneRef.current.controls.target.x,
                    sceneRef.current.controls.target.y,
                    sceneRef.current.controls.target.z,
                  ]
                : null,
            }
          : null;

        const floorBounds = sceneRef.current.getFloorBounds?.();
        const floorMin = floorBounds ? floorBounds.min : { x: 0, y: 0, z: 0 };

        //Thông tin MB,VB
        const countertopData = sceneRef.current.countertop;
        const backsplashData = sceneRef.current.backsplash;
        const ledDecorData = sceneRef.current.ledDecor;

        // 2) Thông tin cabinet tổng
        const cabinetMeta = {
          cabinetType: cabinetType,
          doorType: currentCabinet?.doorType ?? null,
          beveled: currentCabinet?.beveled ?? null,
          dimensions:
            currentCabinet?.formularController?.currentDimensions || null,
          options: currentCabinet?.formularController?.currentOptions || null,
        };

        const mapToObject = m => (m instanceof Map ? Object.fromEntries(m) : m);

        const { frameList, doorList, louveredWallList, shoeLowerBenchList } =
          collectUniqueTextures(currentCabinet.modules);

        const topModules = Array.from(currentCabinet.modules).map(
          ([key, module]) => {
            const group = module.group;
            const groupTRS = insideLoaderRef.current.getLocalTRS(group);
            const insidePayload =
              insideLoaderRef.current.saveInsideDesignOfModule(module);

            const worldPosition = new THREE.Vector3();
            group.getWorldPosition(worldPosition);

            const offsetFromFloor = {
              x: worldPosition.x - floorMin.x,
              y: worldPosition.y - floorMin.y,
              z: worldPosition.z - floorMin.z,
            };

            return {
              moduleId: module.moduleId,
              moduleType: module.cabinetType || null,
              groupTRS,
              offsetFromFloor,
              beveled: module.beveled || null,
              userData: group.userData || null,
              dimensions: module.formularController?.currentDimensions || null,
              options: module.formularController?.currentOptions || null,
              inside: insidePayload,
              textures: mapToObject(module.textures) || null,
            };
          }
        );

        const payload = {
          version: 1,
          dimensions: buildDimensionPayload(dimensionsRef.current),
          dimensionViews: buildViewsPayload(dimensionViewsRef.current),
          savedAt: new Date().toISOString(),
          scene: {
            export: sceneExport,
            camera: cameraState,
          },
          cabinet: cabinetMeta,
          modules: topModules,
          countertop: countertopData,
          backsplash: backsplashData,
        };
        const formData = new FormData();

        formData.append('room_id', selectedRoomId);
        formData.append('product_id', currentProduct?.id);
        formData.append('name', uiData?.name || 'Untitled');
        formData.append('price_no_install', uiData.nonRecurringPrice);
        formData.append('price_with_install', uiData.depositPriceVN);
        formData.append('usd_price_with_install', uiData.depositPriceUS);
        formData.append('description', uiData.code);
        formData.append('data', JSON.stringify(payload));
        formData.append('type', product_type);
        formData.append('type_design', cabinetType);
        formData.append('sale_type ', 'design');

        formData.append('total_wood_price', totalWoodPrice);
        formData.append('total_accessory_price', totalAccessoryPrice);
        formData.append('total_countertop_price', totalCountertopPrice);
        formData.append('total_backsplash_price', totalBacksplashPrice);

        formData.append(
          'price_info',
          JSON.stringify(buildPriceInfo(result, topModules))
        );
        formData.append(
          'is_completed',
          !result?.noTexture && !result?.noGlass && !result?.hasOversizeBoard
        );
        if (result?.useSpecialTexture !== null) {
          formData.append('has_special_texture', result?.useSpecialTexture);
        }
        if (metadata) {
          formData.append('meta_data', JSON.stringify(metadata));
        }

        // Nếu có thumbnail (ảnh chụp màn hình)
        if (uiData?.representativeImage) {
          formData.append('thumbnail', uiData.representativeImage);
        } else {
          const thumbBlob = await captureRoomScreenshot(
            sceneRef.current,
            'canvas3d',
            {
              quality: 0.92,
              format: 'image/jpeg',
              square: true,
              width: 1200,
              height: 1200,
            }
          );
          formData.append('thumbnail', thumbBlob);
        }

        sceneManager.scene.traverse(object => {
          if (
            object.userData.type === InsideType.DOOR ||
            object.userData.type === InsideType.HANDLE
          ) {
            object.visible = false;
            object.raycast = () => {};
          }
        });

        const thumbBlobNoDoor = await captureRoomScreenshot(
          sceneRef.current,
          'canvas3d',
          {
            quality: 0.92,
            format: 'image/jpeg',
            square: true,
            width: 1200,
            height: 1200,
          }
        );

        sceneManager.scene.traverse(object => {
          if (
            object.userData.type === InsideType.DOOR ||
            object.userData.type === InsideType.HANDLE
          ) {
            object.visible = true;
            object.raycast = undefined;
          }
        });

        formData.append('image', thumbBlobNoDoor);

        const productImages = Array.isArray(uiData?.productImages)
          ? uiData.productImages
          : [];
        productImages.forEach((file, idx) => {
          const namedFile = file?.name
            ? file
            : new File([file], `product_${idx + 1}.jpg`, {
                type: file?.type || 'image/jpeg',
              });
          formData.append('images', namedFile);
        });

        // if (uiData?.productImages) {
        //   formData.append("image_urls", uiData.productImages);
        // }

        formData.append('size', JSON.stringify(uiData.dimensions));
        const plank = {
          thicknessKhung: 17,
          thicknessHau: 8,
        };
        formData.append('plank', JSON.stringify(plank));

        const texturesSummary = {
          frame: frameList,
          door: doorList,
          louveredWall: louveredWallList,
          shoeLowerBench: shoeLowerBenchList,
        };
        formData.append('texture', JSON.stringify(texturesSummary));

        const productTypeGroupNames = collectProductTypeGroups(
          currentCabinet,
          sceneManager
        );

        formData.append('item', JSON.stringify(productTypeGroupNames));

        const res = await callApi({
          endpoint: `sale_products/v3/publish_design`,
          method: 'POST',
          data: formData,
        });

        if (!res.data?.success) {
          const errMsg =
            res?.data?.message || res?.statusText || 'Unknown error';
          throw new Error(`API lỗi: ${errMsg}`);
        }

        openMessageSuccess({ content: t('Successfully saved design!') });
      } catch (err) {
        setIsLoadingSave(false);
        console.error('Lỗi khi lưu thiết kế:', err);
        openMessageError({ content: t('Failed to save design!') });
      } finally {
        setIsLoadingSave(false);
      }
    },
    [
      sceneManager,
      sceneRef,
      cabinetType,
      product_type,
      selectedRoomId,
      currentProduct,
      buildPriceInfo,
    ]
  );

  const handleUpdateLibraryDesign = useCallback(
    async uiData => {
      try {
        setIsLoadingSave(true);
        if (!sceneRef.current || !sceneManager) {
          console.warn('SceneManager chưa sẵn sàng.');
          return;
        }

        const currentCabinet = sceneManager.cabinetManager.getCurrentCabinet();
        if (!currentCabinet) {
          console.warn('Chưa có cabinet hiện hành để lưu.');
          return;
        }

        let totalWoodPrice = 0;
        let totalAccessoryPrice = 0;
        let totalCountertopPrice = 0;
        let totalBacksplashPrice = 0;
        let metadata = null;

        const result = await sceneManager?.calculateTotalCost?.({
          isFinal: true,
        });
        // const dataExcel = sceneManager?.getEstimateExcelData?.();

        // if (result?.total?.total === 0) {
        //   openMessageWarning({
        //     content: 'Vui lòng chọn đầy đủ vật liệu và màu sắc trước khi lưu.',
        //   });
        //   return;
        // } else {
        const detailSaleTotals = result?.detailSaleTotals?.vn;
        const aggregatedSaleTotals = result?.aggregatedSaleTotals?.vn;

        totalWoodPrice = roundTo(
          aggregatedSaleTotals?.accessory +
            aggregatedSaleTotals?.component +
            aggregatedSaleTotals?.doors +
            aggregatedSaleTotals?.labor +
            aggregatedSaleTotals?.materials,
          0
        );
        totalAccessoryPrice =
          (detailSaleTotals?.special?.equipments?.total ?? 0) +
          (detailSaleTotals?.special?.curveBlocks ?? 0);
        totalCountertopPrice =
          detailSaleTotals?.special?.countertop?.total ?? 0;
        totalBacksplashPrice =
          detailSaleTotals?.special?.backsplash?.total ?? 0;

        metadata = {
          // price: {
          //   countRail: result?.countRail ?? 0,
          //   countHinge: result?.countHinge ?? 0,
          //   countConnector: result?.countConnector ?? 0,
          //   countertop: result?.countertop ?? 0,
          //   backsplash: result?.backsplash ?? 0,
          //   ledDecor: result?.ledDecor ?? 0,
          // },
        };
        // }

        // 1) Scene chung (tường/sàn/camera)
        const sceneExport = sceneRef.current.exportSceneData?.() || null;
        const camera = sceneRef.current.camera;
        const cameraState = camera
          ? {
              position: [
                camera.position.x,
                camera.position.y,
                camera.position.z,
              ],
              target: sceneRef.current.controls?.target
                ? [
                    sceneRef.current.controls.target.x,
                    sceneRef.current.controls.target.y,
                    sceneRef.current.controls.target.z,
                  ]
                : null,
            }
          : null;

        const floorBounds = sceneRef.current.getFloorBounds?.();
        const floorMin = floorBounds ? floorBounds.min : { x: 0, y: 0, z: 0 };

        //Thông tin MB,VB
        const countertopData = sceneRef.current.countertop;
        const backsplashData = sceneRef.current.backsplash;

        // 2) Thông tin cabinet tổng
        const cabinetMeta = {
          cabinetType: cabinetType,
          doorType: currentCabinet?.doorType ?? null,
          beveled: currentCabinet?.beveled ?? null,
          dimensions:
            currentCabinet?.formularController?.currentDimensions || null,
          options: currentCabinet?.formularController?.currentOptions || null,
        };

        const mapToObject = m => (m instanceof Map ? Object.fromEntries(m) : m);

        const { frameList, doorList, louveredWallList, shoeLowerBenchList } =
          collectUniqueTextures(currentCabinet.modules);

        const topModules = Array.from(currentCabinet.modules).map(
          ([key, module]) => {
            const group = module.group;
            const groupTRS = insideLoaderRef.current.getLocalTRS(group);
            const insidePayload =
              insideLoaderRef.current.saveInsideDesignOfModule(module);

            const worldPosition = new THREE.Vector3();
            group.getWorldPosition(worldPosition);

            const offsetFromFloor = {
              x: worldPosition.x - floorMin.x,
              y: worldPosition.y - floorMin.y,
              z: worldPosition.z - floorMin.z,
            };

            return {
              moduleId: module.moduleId,
              moduleType: module.cabinetType || null,
              groupTRS,
              offsetFromFloor,
              beveled: module.beveled || null,
              userData: group.userData || null,
              dimensions: module.formularController?.currentDimensions || null,
              options: module.formularController?.currentOptions || null,
              inside: insidePayload,
              textures: mapToObject(module.textures) || null,
            };
          }
        );

        const payload = {
          version: 1,
          dimensions: buildDimensionPayload(dimensionsRef.current),
          dimensionViews: buildViewsPayload(dimensionViewsRef.current),
          savedAt: new Date().toISOString(),
          scene: {
            export: sceneExport,
            camera: cameraState,
          },
          cabinet: cabinetMeta,
          modules: topModules,
          countertop: countertopData,
          backsplash: backsplashData,
        };
        const formData = new FormData();

        formData.append('room_id', selectedRoomId);
        formData.append('product_id', currentProduct?.id);
        formData.append('name', uiData?.name || 'Untitled');
        formData.append('price_no_install', uiData.nonRecurringPrice);
        formData.append('price_with_install', uiData.depositPriceVN);
        formData.append('usd_price_with_install', uiData.depositPriceUS);
        formData.append('description', uiData.code);
        formData.append('data', JSON.stringify(payload));
        formData.append('type', product_type);
        formData.append('type_design', cabinetType);
        formData.append('sale_type ', 'design');

        formData.append('total_wood_price', totalWoodPrice);
        formData.append('total_accessory_price', totalAccessoryPrice);
        formData.append('total_countertop_price', totalCountertopPrice);
        formData.append('total_backsplash_price', totalBacksplashPrice);

        formData.append(
          'price_info',
          JSON.stringify(buildPriceInfo(result, topModules))
        );
        formData.append(
          'is_completed',
          !result?.noTexture && !result?.noGlass && !result?.hasOversizeBoard
        );
        if (metadata) {
          formData.append('meta_data', JSON.stringify(metadata));
        }
        if (result?.useSpecialTexture !== null) {
          formData.append('has_special_texture', result?.useSpecialTexture);
        }
        // Nếu có thumbnail (ảnh chụp màn hình)
        if (uiData?.representativeImage) {
          formData.append('thumbnail', uiData.representativeImage);
        } else {
          const thumbBlob = await captureRoomScreenshot(
            sceneRef.current,
            'canvas3d',
            {
              quality: 0.92,
              format: 'image/jpeg',
              square: true,
              width: 1200,
              height: 1200,
            }
          );
          formData.append('thumbnail', thumbBlob);
        }

        sceneManager.scene.traverse(object => {
          if (
            object.userData.type === InsideType.DOOR ||
            object.userData.type === InsideType.HANDLE
          ) {
            object.visible = false;
            // object.raycast = () => {};
          }
        });

        const thumbBlobNoDoor = await captureRoomScreenshot(
          sceneRef.current,
          'canvas3d',
          {
            quality: 0.92,
            format: 'image/jpeg',
            square: true,
            width: 1200,
            height: 1200,
          }
        );

        sceneManager.scene.traverse(object => {
          if (
            object.userData.type === InsideType.DOOR ||
            object.userData.type === InsideType.HANDLE
          ) {
            object.visible = true;
            // object.raycast = undefined;
          }
        });

        formData.append('image', thumbBlobNoDoor);

        const productImages = Array.isArray(uiData?.productImages)
          ? uiData.productImages
          : [];
        productImages.forEach((file, idx) => {
          if (!file) return;
          const namedFile = file?.name
            ? file
            : new File([file], `product_${idx + 1}.jpg`, {
                type: file?.type || 'image/jpeg',
              });
          formData.append('images', namedFile);
        });

        // if (uiData?.productImages) {
        //   formData.append("image_urls", uiData.productImages);
        // }

        formData.append('size', JSON.stringify(uiData.dimensions));
        const plank = {
          thicknessKhung: 17,
          thicknessHau: 8,
        };
        formData.append('plank', JSON.stringify(plank));

        const texturesSummary = {
          frame: frameList,
          door: doorList,
          louveredWall: louveredWallList,
          shoeLowerBench: shoeLowerBenchList,
        };
        formData.append('texture', JSON.stringify(texturesSummary));

        const productTypeGroupNames = collectProductTypeGroups(
          currentCabinet,
          sceneManager
        );

        formData.append('item', JSON.stringify(productTypeGroupNames));

        const res = await callApi({
          endpoint: `sale_products/v3/update_design/${designId}`,
          method: 'PUT',
          data: formData,
        });

        if (!res.data?.success) {
          const errMsg =
            res?.data?.message || res?.statusText || 'Unknown error';
          throw new Error(`API lỗi: ${errMsg}`);
        }

        openMessageSuccess({ content: t('Successfully saved design!') });
      } catch (err) {
        setIsLoadingSave(false);
        console.error('Lỗi khi lưu thiết kế:', err);
        openMessageError({ content: t('Failed to save design!') });
      } finally {
        setIsLoadingSave(false);
      }
    },
    [
      sceneRef,
      cabinetType,
      product_type,
      selectedRoomId,
      currentProduct,
      buildPriceInfo,
    ]
  );

  // ==== SAVE TOÀN BỘ THIẾT KẾ (gọi khi click Save) ====
  const handleUpdateDesign = useCallback(
    async (customSceneManager = null, contrainerId) => {
      try {
        setIsLoadingSave(true);

        const activeSceneManager = customSceneManager || sceneManager;

        if (!sceneRef.current || !activeSceneManager) {
          console.warn('SceneManager chưa sẵn sàng.');
          return;
        }

        let totalWoodPrice = 0;
        let totalAccessoryPrice = 0;
        let totalCountertopPrice = 0;
        let totalBacksplashPrice = 0;
        let metadata = null;

        const result = await activeSceneManager?.calculateTotalCost?.({
          contrainerId,
          isFinal: true,
        });
        // const dataExcel = activeSceneManager?.getEstimateExcelData?.();
        // if (result?.total?.total === 0) {
        //   openMessageWarning({
        //     content: 'Vui lòng chọn đầy đủ vật liệu và màu sắc trước khi lưu.',
        //   });
        //   return;
        // } else {
        const detailSaleTotals = result?.detailSaleTotals?.vn;
        const aggregatedSaleTotals = result?.aggregatedSaleTotals?.vn;

        totalWoodPrice = roundTo(
          aggregatedSaleTotals?.accessory +
            aggregatedSaleTotals?.component +
            aggregatedSaleTotals?.doors +
            aggregatedSaleTotals?.labor +
            aggregatedSaleTotals?.materials,
          0
        );
        totalAccessoryPrice =
          (detailSaleTotals?.special?.equipments?.total ?? 0) +
          (detailSaleTotals?.special?.curveBlocks ?? 0);
        totalCountertopPrice =
          detailSaleTotals?.special?.countertop?.total ?? 0;
        totalBacksplashPrice =
          detailSaleTotals?.special?.backsplash?.total ?? 0;
        // }

        const currentCabinet = sceneManager.cabinetManager.getCurrentCabinet();
        if (!currentCabinet) {
          console.warn('Chưa có cabinet hiện hành để lưu.');
          return;
        }

        const thumbBlob = await captureRoomScreenshot(
          sceneRef.current,
          'canvas3d',
          {
            quality: 0.92,
            format: 'image/jpeg',
            square: true,
            width: 1200,
            height: 1200,
          }
        );

        sceneManager.scene.traverse(object => {
          if (
            object.userData.type === InsideType.DOOR ||
            object.userData.type === InsideType.HANDLE
          ) {
            object.visible = false;
            // object.raycast = () => {};
          }
        });

        const thumbBlobNoDoor = await captureRoomScreenshot(
          sceneRef.current,
          'canvas3d',
          {
            quality: 0.92,
            format: 'image/jpeg',
            square: true,
            width: 1200,
            height: 1200,
          }
        );

        sceneManager.scene.traverse(object => {
          if (
            object.userData.type === InsideType.DOOR ||
            object.userData.type === InsideType.HANDLE
          ) {
            object.visible = true;
            // object.raycast = undefined;
          }
        });

        // 1) Scene chung (tường/sàn/camera)
        const sceneExport = sceneRef.current.exportSceneData?.() || null;
        const camera = sceneRef.current.camera;
        const cameraState = camera
          ? {
              position: [
                camera.position.x,
                camera.position.y,
                camera.position.z,
              ],
              target: sceneRef.current.controls?.target
                ? [
                    sceneRef.current.controls.target.x,
                    sceneRef.current.controls.target.y,
                    sceneRef.current.controls.target.z,
                  ]
                : null,
            }
          : null;

        //Thông tin MB,VB
        const countertopData = sceneRef.current.countertop;
        const backsplashData = sceneRef.current.backsplash;
        const ledDecorData = sceneRef.current.ledDecor;

        // 2) Thông tin cabinet tổng
        const cabinetMeta = {
          cabinetType: cabinetType,
          doorType: currentCabinet?.doorType ?? null,
          beveled: currentCabinet?.beveled ?? null,
          dimensions:
            currentCabinet?.formularController?.currentDimensions || null,
          options: currentCabinet?.formularController?.currentOptions || null,
        };

        const mapToObject = m => (m instanceof Map ? Object.fromEntries(m) : m);

        // 3) Các module khung (top-level) trong cabinet
        //   - Lưu TRS + kích thước + vật liệu của group
        //   - Lưu "inside" theo logic saveDesign bạn đã cung cấp
        const topModules = Array.from(currentCabinet.modules).map(
          ([key, module]) => {
            const group = module.group;
            const groupTRS = insideLoaderRef.current.getLocalTRS(group);
            const insidePayload =
              insideLoaderRef.current.saveInsideDesignOfModule(module);

            return {
              moduleId: module.moduleId,
              moduleType: module.cabinetType || null,
              groupTRS,
              beveled: module.beveled || null,
              userData: group.userData || null,
              dimensions: module.formularController?.currentDimensions || null,
              options: module.formularController?.currentOptions || null,
              inside: insidePayload,
              textures: mapToObject(module.textures) || null,
            };
          }
        );

        const payload = {
          version: 1,
          dimensions: buildDimensionPayload(dimensionsRef.current),
          dimensionViews: buildViewsPayload(dimensionViewsRef.current),
          savedAt: new Date().toISOString(),
          scene: {
            export: sceneExport, // dữ liệu layout tường/sàn từ WallSetupForm
            camera: cameraState,
            // appearance: sceneAppearance,
          },
          cabinet: cabinetMeta,
          modules: topModules,
          countertop: countertopData,
          backsplash: backsplashData,
          ledDecor: ledDecorData,
        };

        if (design_id) {
          const formData = new FormData();

          const daeFile =
            await activeSceneManager.exportToDAE?.('design_model.dae');
          formData.append('su_file', daeFile);

          // Các trường bắt buộc theo API
          formData.append('name', nameDesign || 'Untitled');
          formData.append('cabinet_trim', JSON.stringify(cbTrim));
          formData.append('data', JSON.stringify(payload));
          formData.append('type_design', cabinetType);
          // formData.append('price_with_install', result.grand?.vn);
          formData.append('usd_price_with_install', result.grand?.us);
          formData.append('total_wood_price', totalWoodPrice);
          formData.append('total_accessory_price', totalAccessoryPrice);
          formData.append('total_countertop_price', totalCountertopPrice);
          formData.append('total_backsplash_price', totalBacksplashPrice);

          formData.append(
            'price_info',
            JSON.stringify(buildPriceInfo(result, topModules))
          );
          formData.append(
            'is_completed',
            !result?.noTexture && !result?.noGlass && !result?.hasOversizeBoard
          );
          if (result?.useSpecialTexture !== null) {
            formData.append('has_special_texture', result?.useSpecialTexture);
          }

          if (metadata) {
            formData.append('meta_data', JSON.stringify(metadata));
          }

          // Nếu có thumbnail (ảnh chụp màn hình)
          if (thumbBlob) {
            formData.append('thumbnail', thumbBlob);
          }
          if (thumbBlobNoDoor) {
            formData.append('image', thumbBlobNoDoor);
          }

          const res = await callApi({
            endpoint: `rooms/v3/design/${design_id}`,
            method: 'PUT',
            data: formData,
          });

          if (!res.data?.success) {
            const errMsg =
              res?.data?.message || res?.statusText || 'Unknown error';
            throw new Error(`API lỗi: ${errMsg}`);
          }

          openMessageSuccess({ content: t('Successfully updated design!') });
        }
        // message.success("Đã lưu thiết kế vào trình duyệt!");
      } catch (err) {
        setIsLoadingSave(false);
        console.error('Lỗi khi chỉnh sửa thiết kế:', err);
        openMessageError({ content: t('Failed to update design!') });
      } finally {
        setIsLoadingSave(false);
      }
    },
    [
      sceneManager,
      sceneRef,
      cabinetType,
      product_type,
      selectedRoomId,
      currentProduct,
      nameDesign,
      buildPriceInfo,
    ]
  );

  // ==== SAVE TOÀN BỘ THIẾT KẾ (gọi khi click Save) ====
  const handleSaveAllDesign = useCallback(
    async ({
      complete,
      customSceneManager = null,
      nameDesignNew,
      containerId,
    }) => {
      try {
        setIsLoadingSave(true);

        const activeSceneManager = customSceneManager || sceneManager;

        if (!sceneRef.current || !activeSceneManager) {
          console.warn('SceneManager chưa sẵn sàng.');
          return;
        }

        let totalWoodPrice = 0;
        let totalAccessoryPrice = 0;
        let totalCountertopPrice = 0;
        let totalBacksplashPrice = 0;
        let metadata = null;

        const result = await activeSceneManager?.calculateTotalCost?.({
          containerId,
          isFinal: true,
        });
        // const dataExcel = activeSceneManager?.getEstimateExcelData?.();

        if (complete !== true) {
          // if (result?.total?.total === 0) {
          //   openMessageWarning({
          //     content: 'Vui lòng chọn đầy đủ vật liệu và màu sắc trước khi lưu.',
          //   });
          //   return;
          // } else {
          const detailSaleTotals = result?.detailSaleTotals?.vn;
          const aggregatedSaleTotals = result?.aggregatedSaleTotals?.vn;

          totalWoodPrice = roundTo(
            aggregatedSaleTotals?.accessory +
              aggregatedSaleTotals?.component +
              aggregatedSaleTotals?.doors +
              aggregatedSaleTotals?.labor +
              aggregatedSaleTotals?.materials,
            0
          );
          totalAccessoryPrice =
            (detailSaleTotals?.special?.equipments?.total ?? 0) +
            (detailSaleTotals?.special?.curveBlocks ?? 0);
          totalCountertopPrice =
            detailSaleTotals?.special?.countertop?.total ?? 0;
          totalBacksplashPrice =
            detailSaleTotals?.special?.backsplash?.total ?? 0;
        }
        // }

        const currentCabinet = sceneManager.cabinetManager.getCurrentCabinet();
        if (!currentCabinet) {
          console.warn('Chưa có cabinet hiện hành để lưu.');
          return;
        }

        const thumbBlob = await captureRoomScreenshot(
          sceneRef.current,
          'canvas3d',
          {
            quality: 0.92,
            format: 'image/jpeg',
            square: true,
            width: 1200,
            height: 1200,
          }
        );

        sceneManager.scene.traverse(object => {
          if (
            object.userData.type === InsideType.DOOR ||
            object.userData.type === InsideType.HANDLE
          ) {
            object.visible = false;
            // object.raycast = () => {};
          }
        });

        const thumbBlobNoDoor = await captureRoomScreenshot(
          sceneRef.current,
          'canvas3d',
          {
            quality: 0.92,
            format: 'image/jpeg',
            square: true,
            width: 1200,
            height: 1200,
          }
        );

        sceneManager.scene.traverse(object => {
          if (
            object.userData.type === InsideType.DOOR ||
            object.userData.type === InsideType.HANDLE
          ) {
            object.visible = true;
            // object.raycast = undefined;
          }
        });

        // 1) Scene chung (tường/sàn/camera)
        const sceneExport = sceneRef.current.exportSceneData?.() || null;
        const camera = sceneRef.current.camera;
        const cameraState = camera
          ? {
              position: [
                camera.position.x,
                camera.position.y,
                camera.position.z,
              ],
              target: sceneRef.current.controls?.target
                ? [
                    sceneRef.current.controls.target.x,
                    sceneRef.current.controls.target.y,
                    sceneRef.current.controls.target.z,
                  ]
                : null,
            }
          : null;

        //Thông tin MB,VB
        const countertopData = sceneRef.current.countertop;
        const backsplashData = sceneRef.current.backsplash;
        const ledDecorData = sceneRef.current.ledDecor;

        // 2) Thông tin cabinet tổng
        const cabinetMeta = {
          cabinetType: cabinetType,
          doorType: currentCabinet?.doorType ?? null,
          beveled: currentCabinet?.beveled ?? null,
          dimensions:
            currentCabinet?.formularController?.currentDimensions || null,
          options: currentCabinet?.formularController?.currentOptions || null,
        };

        const mapToObject = m => (m instanceof Map ? Object.fromEntries(m) : m);

        // 3) Các module khung (top-level) trong cabinet
        //   - Lưu TRS + kích thước + vật liệu của group
        //   - Lưu "inside" theo logic saveDesign bạn đã cung cấp
        const topModules = Array.from(currentCabinet.modules).map(
          ([key, module]) => {
            const group = module.group;
            const groupTRS = insideLoaderRef.current.getLocalTRS(group);
            const insidePayload =
              insideLoaderRef.current.saveInsideDesignOfModule(module);

            return {
              moduleId: module.moduleId,
              moduleType: module.cabinetType || null,
              groupTRS,
              beveled: module.beveled || null,
              userData: group.userData || null,
              dimensions: module.formularController?.currentDimensions || null,
              options: module.formularController?.currentOptions || null,
              inside: insidePayload,
              textures: mapToObject(module.textures) || null,
            };
          }
        );

        // 4) Vật liệu/diện mạo chung của scene
        // const sceneAppearance = {
        //   wallColor: appearance?.wallColor || null,
        //   floorTexId: appearance?.floorTexId || null,
        //   floorRepeat: appearance?.floorRepeat || null,
        //   // nếu có textureDoor / textureFrame chọn riêng:
        //   textureDoor: textureDoor || null,
        //   textureFrame: textureFrame || null,
        // };

        const payload = {
          version: 1,
          dimensions: buildDimensionPayload(dimensionsRef.current),
          dimensionViews: buildViewsPayload(dimensionViewsRef.current),
          savedAt: new Date().toISOString(),
          scene: {
            export: sceneExport, // dữ liệu layout tường/sàn từ WallSetupForm
            camera: cameraState,
            // appearance: sceneAppearance,
          },
          cabinet: cabinetMeta,
          modules: topModules,
          countertop: countertopData,
          backsplash: backsplashData,
          ledDecor: ledDecorData,
        };

        if (complete === true) {
          setDataDesign({
            ...payload,
            is_completed:
              !result?.noTexture &&
              !result?.noGlass &&
              !result?.hasOversizeBoard
                ? true
                : false,
          });
        } else {
          const formData = new FormData();

          const daeFile =
            await activeSceneManager.exportToDAE?.('design_model.dae');
          formData.append('su_file', daeFile);

          // Các trường bắt buộc theo API
          formData.append('name', nameDesignNew || nameDesign || 'Untitled');
          formData.append('cabinet_trim', JSON.stringify(cbTrim));
          formData.append('data', JSON.stringify(payload));
          formData.append('type', product_type);
          formData.append('type_design', cabinetType);
          // formData.append('price_with_install', result?.grand?.vn);
          formData.append('usd_price_with_install', result?.grand?.us);
          formData.append('total_wood_price', totalWoodPrice);
          formData.append('total_accessory_price', totalAccessoryPrice);
          formData.append('total_countertop_price', totalCountertopPrice);
          formData.append('total_backsplash_price', totalBacksplashPrice);
          formData.append('room_id', selectedRoomId); // room_id từ props hoặc params

          formData.append(
            'price_info',
            JSON.stringify(buildPriceInfo(result, topModules))
          );
          formData.append(
            'is_completed',
            !result?.noTexture && !result?.noGlass && !result?.hasOversizeBoard
              ? true
              : false
          );
          if (result?.useSpecialTexture !== null) {
            formData.append('has_special_texture', result?.useSpecialTexture);
          }

          if (metadata) {
            formData.append('meta_data', JSON.stringify(metadata));
          }

          // Trường không bắt buộc
          // if (description) {
          //   formData.append('description', description);
          // }

          // Nếu có thumbnail (ảnh chụp màn hình)
          if (thumbBlob) {
            formData.append('thumbnail', thumbBlob);
          }
          if (thumbBlobNoDoor) {
            formData.append('image', thumbBlobNoDoor);
          }

          const jsonData = JSON.stringify(payload);

          const res = await callApi({
            endpoint: `rooms/v3/room/${selectedRoomId}/design`,
            method: 'POST',
            data: formData,
          });

          if (!res.data?.success) {
            const errMsg =
              res?.data?.message || res?.statusText || 'Unknown error';
            throw new Error(`API lỗi: ${errMsg}`);
          }

          if (res.data?.result?.data?.id) {
            setDesignId(res.data.result?.data?.id); // Lưu design_id để lần sau update

            const params = new URLSearchParams(searchParams);
            params.set('design_id', res.data.result?.data.id);
            setSearchParams(params);
          }

          openMessageSuccess({ content: t('Successfully saved design!') });
          return res.data.result?.data?.id;
        }
        // message.success("Đã lưu thiết kế vào trình duyệt!");
      } catch (err) {
        setIsLoadingSave(false);
        console.error('Lỗi khi lưu thiết kế:', err);
        openMessageError({ content: t('Failed to save design!') });
      } finally {
        setIsLoadingSave(false);
      }
    },
    [
      sceneManager,
      cabinetType,
      sceneRef,
      insideLoaderRef,
      product_type,
      selectedRoomId,
      searchParams,
      nameDesign,
      buildPriceInfo,
    ]
  );

  const calcFloorRepeat = (width = 5, depth = 5, tileMeters = 1.2) => {
    // tileMeters = kích thước “ô” thật của texture (m). Tùy texture bạn chỉnh lại.
    const maxLen = Math.max(width, depth);
    return Math.max(1, Math.ceil(maxLen / tileMeters));
  };

  async function applyInsideToModule({
    payload,
    moduleInstance,
    currentCabinet,
    insideLoader,
  }) {
    if (insideLoader) {
      await insideLoader.loadInsideDesignOfModule(
        payload,
        moduleInstance,
        currentCabinet,
        currentProduct
      );

      // insideLoader.adjustBackPanelForHPanel(moduleInstance, sceneManager);
    } else {
      await insideLoaderRef.current.loadInsideDesignOfModule(
        payload,
        moduleInstance,
        currentCabinet,
        currentProduct
      );

      // insideLoaderRef.current.adjustBackPanelForHPanel(
      //   moduleInstance,
      //   sceneManager
      // );
    }

    // await insideLoaderRef.current.adjustBackPanelForHPanel(
    //   moduleInstance,
    //   sceneManager
    // );
  }

  const loadDesignFromStorage = async () => {
    try {
      const STORAGE_KEY = `fitta:design:${cabinetType}`;
      const raw = localStorage.getItem(STORAGE_KEY);
      if (!raw) return null;

      let data;
      try {
        data = JSON.parse(raw);
      } catch (parseErr) {
        console.error('Failed to parse local storage design data:', parseErr);
        openMessageWarning({ content: t('Local design data is corrupted') });
        return null;
      }

      // 1) Khôi phục scene nền (tường/sàn) + appearance
      if (data.scene?.export && sceneRef.current?.importSceneData) {
        sceneRef.current.importSceneData(data.scene.export);
      }

      if (
        data.scene?.export?.wallTexture &&
        data.scene?.export?.floorTexture &&
        data.scene?.export?.floorSize
      ) {
        const foundTex = FLOOR_TEXTURES.find(
          t => t.img === data.scene?.export?.floorTexture
        );

        // 2) Tính repeat theo kích thước sàn
        const repeatBy = calcFloorRepeat(
          data.floorSize?.width,
          data.floorSize?.depth
        );

        const newAppearance = {
          wallColor: data.scene?.export?.wallTexture || '#FCFCFC',
          floorTexId: foundTex ? foundTex.id : null,
          floorRepeat: repeatBy,
        };

        setAppearance(newAppearance);
      }

      // 2) Khởi tạo cabinet
      if (!sceneManager) {
        openMessageWarning({ content: t('SceneManager is not ready!') });
        return data;
      }

      startCabinetDesign(data.cabinet?.cabinetType || cabinetType);

      // 3) Load lại modules từ API và tái dựng
      for (const m of data.modules || []) {
        try {
          // ===== FETCH MODULE DATA TỪ API (GIỐNG CARDPRODUCT) =====
          const action = await dispatch(fetchModule(m.moduleId));

          if (!action?.payload?.data) {
            openMessageError({
              content: t(`Failed to load module {{moduleId}}`, {
                moduleId: m.moduleId,
              }),
            });
            continue;
          }

          let moduleData = action.payload.data;

          moduleData = {
            ...moduleData,
            settings: { dimensions: m.dimensions, options: m.options },
          };

          if (m.beveled !== undefined) {
            moduleData.beveled = m.beveled;
          }

          // ===== LOAD MODULE VÀO SCENE =====
          const moduleInstance = await sceneManager.loadCabinetModule(
            moduleData,
            m.moduleType
          );

          if (!moduleInstance?.group) {
            console.warn(`Không thể tạo instance cho module ${m.moduleId}`);
            continue;
          }

          // ===== SET TRS CHO GROUP =====
          const g = moduleInstance.group;
          // Khôi phục id bền để DIM tìm lại được module sau khi load
          if (m.userData?.instanceId) {
            g.userData.instanceId = m.userData.instanceId;
          }
          const [px, py, pz] = m.groupTRS.p;
          const [rx, ry, rz] = m.groupTRS.r;
          // const [sx, sy, sz] = m.groupTRS.s;

          g.position.set(px, py, pz);
          g.rotation.set(rx, ry, rz);
          // g.scale.set(sx, sy, sz);
          g.updateMatrixWorld(true);

          // ===== THÊM VÀO POSITION CONTROLLER (GIỐNG ADDCABINETMODULE) =====
          if (sceneManager.positionController) {
            const clonedScene = g.clone();
            clonedScene.children = [
              clonedScene.children?.find(x => x.type === 'Group'),
            ];
            clonedScene.rotation.set(0, 0, 0);
            clonedScene.updateMatrixWorld(true);

            const box = new THREE.Box3().setFromObject(clonedScene);
            const size = new THREE.Vector3();
            box.getSize(size);
            const center = new THREE.Vector3();
            box.getCenter(center);

            sceneManager.positionController.addModule({
              id: g.uuid,
              x: center.x,
              y: center.y - size.y / 2,
              z: center.z,
              width: size.x,
              height: size.y,
              depth: size.z,
              rotate: g.rotation,
              group: moduleInstance.group,
            });
          }

          const currentCabinet =
            sceneManager.cabinetManager.getCurrentCabinet();

          // Load từng inside item
          const payload = m.inside;
          if (m.inside) {
            await applyInsideToModule({
              payload,
              moduleInstance,
              currentCabinet,
              insideLoader: insideLoaderRef.current,
            });
          }

          // ===== CẬP NHẬT LIST MODULE =====
          setListModule(prev => [...prev, moduleInstance]);
        } catch (error) {
          console.error(`Lỗi khi load module ${m.moduleId}:`, error);
          // openMessageError({ content: `Không thể tải module ${m.moduleId}` });
        }
      }

      // // ===== TỰ ĐỘNG FIT CEILING (NẾU CÓ UPPER) =====
      // if (data.modules?.some((m) => m.moduleType?.includes("upper"))) {
      //   openModalFitHeight({
      //     func: () => {
      //       sceneManager.autoFitModuleController?.moveCeilingFollowHeightestUpperCabinet(
      //         { insideLoaderRef }
      //       );
      //     },
      //   });
      // }

      // 4) Khôi phục camera
      // Khôi phục DIM sau khi module đã load (anchor tìm theo instanceId)
      dispatch(setDimensions(parseDimensions(data.dimensions)));
      dispatch(setDimensionViews(parseViews(data.dimensionViews)));

      if (data.scene?.camera && sceneRef.current?.controls) {
        const c = data.scene.camera;
        if (c.position) {
          const [x, y, z] = c.position;
          sceneRef.current.camera.position.set(x, y, z);
        }
        if (c.target) {
          const [tx, ty, tz] = c.target;
          sceneRef.current.controls.target.set(tx, ty, tz);
        }
        sceneRef.current.camera.updateProjectionMatrix?.();
        sceneRef.current.render?.();
      }

      // message.success("Đã load lại thiết kế!");
      // ===== TÍNH TOÁN TỔNG CHI PHÍ =====
      await sceneManager?.calculateTotalCost?.({});
      return data;
    } catch (e) {
      console.error('Lỗi khi load thiết kế:', e);
      openMessageError({ content: t('Failed to load design!') });
      return null;
    }
  };

  // ===== CONTEXT VALUE (CẬP NHẬT) =====
  const contextValue = {
    // ===== VALUES CŨ =====
    listModule,
    setListModule,
    sceneManager,
    loadModule,
    removeModule,
    clearAllModules,
    selectedModel,
    setSelectedModel,
    selectedModelScreenPos,
    isDragging,
    currentProduct,

    // ===== VALUES MỚI =====
    currentCabinetType,
    currentCabinet,
    availableModuleTypes,
    startCabinetDesign,
    addCabinetModule,
    finishCabinetDesign,
    mdSelectedModelData,
    setMdSelectedModelData,
    setOpenExampleRecommend,
    openExampleRecommend,
    fetchDesignLibraryDetail,
    showEditForm,
    editingModule,
    handleSaveModuleEdit,
    selectedModels,
    setSelectedModels,
    cabinetType,
    type: cabinetType,
    showCabinetEditor,
    setShowCabinetEditor,
    showCabinetEditor,
    supplierId,
    setSupplierId,
    currentMaterial,
    setCurrentMaterial,
    isDesignLibrary,

    handleUpdateDesign,
    // materialType,
    // setMaterialType,
    // textureFrame,
    // setTextureFrame,
    textureDoor,
    setTextureDoor,
    openRightDoorAccessoryDesignMenu,
    setOpenRightDoorAccessoryDesignMenu,
    liftSupport,
    openRightLiftSupportDesignMenu,
    setOpenRightLiftSupportDesignMenu,
    showCabinetTrimView,
    setShowCabinetTrimView,

    insideLoaderRef,
    meshClickRef,
    childClickRef,
    handleSaveAllDesign,
    loadDesignFromStorage,

    designId,
    isDesignLibrary,

    sceneRef,
    tick,
    setTick,
    setShowNavDesign,
    // ===== DEBUG =====

    setNameDesign,
    nameDesign,

    openSaveLibraryModal,
    setOpenSaveLibraryModal,
    handleSaveLibraryDesign,
    setShowSaveLibraryModule,
    needUpdatePrice,
    testSaveLibrary,

    // ===== Thêm nẹp =====
    cabinetType,
    FLOOR_TEXTURES,
    setAppearance,
    fetchModule,
    startCabinetDesign,
    applyInsideToModule,
    insideLoaderRef,
    setListModule,
    dataDesign,
    setDataDesign,
    // ===== Thêm nẹp =====
    isDimensioning,
    setIsDimensioning,
    isHideDoor,
    setIsHideDoor,
    isOpenDoor,
    setIsOpenDoor,
    cbTrim,
    setCbTrim,

    product_type,

    handleExport,
    groupDoorId,
    setGroupDoorId,
  };

  // helper: nếu khoá thì bỏ qua handler
  const guard =
    fn =>
    (...args) => {
      if (lockedRef.current) return;
      return fn(...args);
    };

  // ========= Helpers =========
  const updateMouseFromEvent = event => {
    const canvas = document.getElementById('canvas3d');
    if (!canvas || !sceneRef.current) return;
    const rect = canvas.getBoundingClientRect();
    mousePositionRef.current.x =
      ((event.clientX - rect.left) / rect.width) * 2 - 1;
    mousePositionRef.current.y =
      -((event.clientY - rect.top) / rect.height) * 2 + 1;
    raycasterRef.current.setFromCamera(
      mousePositionRef.current,
      sceneRef.current.camera
    );
  };

  const distanceYZ = (p1, p2) => {
    const dy = p1.y - p2.y,
      dz = p1.z - p2.z;
    return Math.sqrt(dy * dy + dz * dz);
  };
  const distanceYX = (p1, p2) => {
    const dy = p1.y - p2.y,
      dx = p1.x - p2.x;
    return Math.sqrt(dy * dy + dx * dx);
  };
  const round3 = num => {
    return Math.round(num * 1000) / 1000;
  };

  const findClosestPoint = (door, inputPoint, listPoints, min = 0.2) => {
    let best = null,
      dmin = min;
    const orientation = GeometryUtils.getModuleOrientation(
      meshClickRef.current
    );

    listPoints?.forEach(pt => {
      let d;
      if (orientation === 'NORMAL' || orientation === 'ROTATED_180') {
        d = distanceYZ(inputPoint, pt.position);
      } else if (
        orientation === 'ROTATED_90' ||
        orientation === 'ROTATED_270'
      ) {
        d = distanceYX(inputPoint, pt.position);
      }

      if (d < dmin) {
        dmin = d;
        best = pt;
      }
    });

    if (best && !door.userData?.drawerUuid) {
      const bestPos = best.getWorldPosition(new THREE.Vector3());
      const doorPos = door.getWorldPosition(new THREE.Vector3());

      const doorBox = new THREE.Box3().setFromObject(door);
      const doorSize = new THREE.Vector3();
      doorBox.getSize(doorSize);

      const doorSizeReal = Math.max(doorSize.x, doorSize.z);
      const limitWidth = door.userData?.limit?.width?.max || LimitDoor.WIDTH;

      let d1, d2;

      if (orientation === 'NORMAL') {
        //Cùng X nên tính theo Z
        d1 = round3(Math.abs(bestPos.z - doorPos.z));
        d2 = round3(Math.abs(bestPos.z - (doorPos.z - doorSizeReal)));
      } else if (orientation === 'ROTATED_90') {
        //Cùng Z tính theo X
        d1 = round3(Math.abs(bestPos.x - doorPos.x));
        d2 = round3(Math.abs(bestPos.x - (doorPos.x - doorSizeReal)));
      } else if (orientation === 'ROTATED_180') {
        //Cùng X nên tính theo Z
        d1 = round3(Math.abs(bestPos.z - doorPos.z));
        d2 = round3(Math.abs(bestPos.z - (doorPos.z + doorSizeReal)));
      } else if (orientation === 'ROTATED_270') {
        //Cùng Z tính theo X
        d1 = round3(Math.abs(bestPos.x - doorPos.x));
        d2 = round3(Math.abs(bestPos.x - (doorPos.x + doorSizeReal)));
      }

      if (d1 <= limitWidth && d2 <= limitWidth) {
        return best;
      }
    }
    if (door.userData?.drawerUuid) {
      return best;
    }
  };

  const project3DToScreen = position3D => {
    if (!sceneRef.current || !position3D) return null;

    const canvas = document.getElementById('canvas3d');
    if (!canvas) return null;

    const vector = new THREE.Vector3();
    vector.copy(position3D);
    vector.project(sceneRef.current.camera);

    const rect = canvas.getBoundingClientRect();
    const x = (vector.x * 0.5 + 0.5) * rect.width + rect.left;
    const y = (-vector.y * 0.5 + 0.5) * rect.height + rect.top;

    return { x, y };
  };

  const updateMoveButtonPosition = targetMesh => {
    if (!targetMesh || !sceneRef.current) {
      setShowMoveButton(false);
      return;
    }

    const box = new THREE.Box3().setFromObject(targetMesh);

    // Tính center thủ công từ min và max
    const centerPos = new THREE.Vector3(
      (box.min.x + box.max.x) / 2,
      (box.min.y + box.max.y) / 2,
      (box.min.z + box.max.z) / 2
    );

    const screenPos = project3DToScreen(centerPos);
    if (screenPos) {
      setMoveButtonPos(screenPos);
      setShowMoveButton(true);
    }
  };

  const loadRealModelWithInsideLoader = async (
    moduleData,
    intersection,
    module,
    currentCabinet,
    typeHau
  ) => {
    const skipCheckTypes = [
      InsideType.DOOR,
      InsideType.BRACE,
      InsideType.HANDLE,
    ];
    const type = moduleData.type;

    if (!skipCheckTypes.includes(type)) {
      const isAllowed = module.exclude_types?.includes(type);
      if (!isAllowed) {
        openMessageError({
          content: t('{{name}} cannot be added to this module.', {
            name: getValueFromString(moduleData?.name),
          }),
        });
        return;
      }
    }
    if (moduleData.type === InsideType.ACCESSORY_FLIP) {
      if (module.formularController?.currentDimensions?.depth < 0.333) {
        openMessageError({
          content: t(
            '{{name}} can only be added to modules with a depth greater than 350mm.',
            { name: getValueFromString(moduleData?.name) }
          ),
        });
        return;
      }
    }
    if (insideLoaderRef.current) {
      await insideLoaderRef.current.loadRealModel(
        moduleData,
        intersection,
        module,
        currentCabinet,
        null,
        typeHau,
        liftSupport?.data
      );

      setTick(t => t + 1);

      if (
        moduleData.type === InsideType.VPANEL ||
        moduleData.type === InsideType.VPANEL2
      ) {
        await insideLoaderRef.current.adjustBackPanelForHPanel(
          module,
          sceneManager
        );
      }

      setTimeout(async () => {
        await sceneManager.textureController.reloadTexture({ module });
        await sceneManager?.calculateTotalCost?.({});
      }, 300);
    } else {
      console.error('InsideLoader instance not available');
    }
  };

  const handleDragStart = (e, module) => {
    e.preventDefault();
    if (!sceneRef.current) return;
    isDraggingRef.current = true;
    draggedModuleRef.current = module;

    if (meshClickRef.current) {
      meshClickRef.current = null;
      insideLoaderRef.current?.clearLine();
      insideLoaderRef.current?.clearLabel();
      childClickRef.current = null;
      sceneRef.current?.removeBoxes?.();
      sceneRef.current?.removeAllPoints?.();
      sceneRef.current?.removeWireframeBoxes?.();
      setShowMoveButton(false);
    }

    sceneRef.current.loadModulePreview(module).then(preview => {
      if (preview) {
        sceneRef.current.scene.add(preview);
        previewModelRef.current = preview;
        updatePreviewFromEvent(e);
      }
    });
  };

  // Thay thế handleCanvasClick hiện tại
  const handleCanvasClick = useCallback(
    event => {
      const canvas = document.getElementById('canvas3d');
      if (event.target !== canvas || !sceneRef.current) return;

      updateMouseFromEvent(event);

      const currentCabinet = sceneManager?.cabinetManager?.getCurrentCabinet();
      if (!currentCabinet) return;

      // Lấy intersections từ cabinet modules
      const intersects = raycasterRef.current.intersectObjects(
        currentCabinet.cabinetGroup,
        true
      );

      if (!intersects?.length) {
        meshClickRef.current = null;
        insideLoaderRef.current?.clearLine();
        insideLoaderRef.current?.clearLabel();
        childClickRef.current = null;
        sceneRef.current?.removeBoxes?.();
        sceneRef.current?.removeAllPoints?.();
        sceneRef.current?.removeWireframeBoxes?.();
        setShowMoveButton(false); // ẨN BUTTON
        setShowNavDesign(false);
        setTick(t => t + 1);
        return;
      }

      const hit = intersects[0].object;
      if (
        cabinetType === TypeCabinet.KITCHEN &&
        hit.userData.type !== ModuleType.COUNTERTOP &&
        hit.userData.type !== ModuleType.BACKSPLASH
      ) {
        return;
      }

      let picked = null;

      // Tìm inside object từ hit

      if (hit?.userData?.isClone) {
        if (hit?.userData?.type === InsideType.DOOR_CLONE) {
          picked = hit.parent;
        } else if (hit?.userData?.type === InsideType.MIRROR_DOOR) {
          picked = hit;
        }
      } else if (
        hit?.userData?.type === InsideType.HANDLE &&
        meshClickRef.current?.userData?.type === InsideType.ACCESSORY_GENERAL
      ) {
        picked = meshClickRef.current;
        childClickRef.current = hit;
      } else {
        const parentUuid = hit?.userData?.parentGltf;
        if (parentUuid) {
          // Tìm parent trong tất cả modules
          currentCabinet.modules.forEach(module => {
            const parent = module.group.children.find(
              ch => ch.uuid === parentUuid
            );
            if (parent) picked = parent;
          });
          picked = picked || hit;
          if (
            picked.userData?.isChildUDrawer &&
            picked.userData?.parentUDrawerUuid
          ) {
            const parentUuid = picked?.userData?.parentUDrawerUuid;
            currentCabinet.modules.forEach(module => {
              const parent = module.group.children.find(
                ch => ch.uuid === parentUuid
              );
              if (parent) picked = parent;
            });
          }
          picked = picked || hit;
        } else {
          picked = hit;
        }
        childClickRef.current = null;
      }

      const model = findTopLevelParent(picked);

      const foundModule = currentCabinet.getModuleByGroupUuid(model?.uuid);

      if (
        picked?.userData?.type !== undefined &&
        picked?.userData?.type !== InsideType.COL_PANEL &&
        picked?.userData?.type !== InsideType.STOOL_CUSHION
      ) {
        setTick(t => t + 1);
        meshClickRef.current = picked;
        //Trường hợp cho cửa hộc chữ U
        if (picked?.userData?.type === picked?.parent?.userData?.type) {
          meshClickRef.current = picked.parent;
        }

        setShowNavDesign(true);

        // Tạo visual feedback
        if (
          picked.userData.type === ModuleType.COUNTERTOP ||
          picked.userData.type === ModuleType.BACKSPLASH
        ) {
          const sameType = sceneManager.getAllModelByType(picked.userData.type);

          setSelectedModel(picked);
          // setSelectedModels([picked]);
          setSelectedModels(sameType);
        } else if (picked.userData.type !== InsideType.DOOR) {
          const boxData = insideLoaderRef?.current?.drawBoxBorder?.(
            picked,
            currentCabinet,
            foundModule
          );
          if (
            picked.userData.type !== InsideType.DOOR_CLONE &&
            picked.userData.type !== InsideType.MIRROR_DOOR &&
            picked.userData.type !== InsideType.HPANEL_RIGHT &&
            picked.userData.type !== InsideType.HPANEL_LEFT &&
            picked.userData.type !== InsideType.U_DRAWER
          ) {
            sceneRef.current?.createBoxBorder?.(boxData);
            updateMoveButtonPosition(picked);
          }

          if (
            ![
              InsideType.DRAWER,
              // InsideType.U_DRAWER,
              InsideType.ACCESSORY,
            ].includes(picked.userData.type)
          ) {
            sceneRef.current?.createWireframeBox?.(picked);
          }
          if (
            picked.userData.type === InsideType.DRAWER ||
            picked.userData.type === InsideType.MIRROR_DOOR
          ) {
            sceneRef.current?.createWireframeBoxGap?.(picked);
          }

          // HIỂN THỊ MOVE BUTTON

          //Ẩn 4 góc cửa cưa nếu có chọn cửa trước đó
          doorCornersRef.current = sceneRef.current?.setPointDoor?.(null);
        } else {
          //Set select model bằng model cha khi click vào cửa
          // setSelectedModel(picked?.parent);
          // setSelectedModels([picked?.parent]);

          const md = findTopLevelParent(picked);
          setSelectedModel(md);
          setSelectedModels([md]);

          doorCornersRef.current = sceneRef.current?.setPointDoor?.(picked);

          setShowMoveButton(false); // ẨN BUTTON CHO DOOR

          //Xoá đi khung bao cho inside được click trước đó và thước đo khoảng cách
          sceneRef.current?.removeBoxes?.();
          sceneRef.current?.removeWireframeBoxes?.();
          insideLoaderRef.current?.clearLine();
          insideLoaderRef.current?.clearLabel();
        }
      } else {
        childClickRef.current = null;
        doorCornersRef.current = [];
        setShowMoveButton(false); // ẨN BUTTON
        setShowNavDesign(false);
      }
    },
    [
      sceneManager,
      cabinetType,
      updateMouseFromEvent,
      setShowMoveButton,
      setShowNavDesign,
      setTick,
      setSelectedModel,
      setSelectedModels,
      updateMoveButtonPosition,
    ]
  );

  const getAdjustedPoint = (intersectionPoint, model, wallName) => {
    if (!model) return intersectionPoint.clone();

    const box = new THREE.Box3().setFromObject(model);
    const size = new THREE.Vector3();
    box.getSize(size);

    let adjusted = intersectionPoint.clone();
    adjusted.y -= size.y / 2;

    switch (wallName) {
      case 'left':
        adjusted.z += model.userData.size.z / 2;
        break;
      case 'front':
        adjusted.x -= model.userData.size.z / 2;
        break;
      case 'back':
        adjusted.x += model.userData.size.z / 2;
        break;
      case 'right':
        break;
      default:
        break;
    }

    return adjusted;
  };
  const getAdjustedPointMesh = (intersectionPoint, model, wallName) => {
    if (!model) return intersectionPoint.clone();

    const box = new THREE.Box3().setFromObject(model);
    const size = new THREE.Vector3();
    box.getSize(size);

    let adjusted = intersectionPoint.clone();
    adjusted.y -= size.y / 2;

    switch (wallName) {
      case 'NORMAL':
        adjusted.z += model.userData.size.z / 2;
        break;
      case 'ROTATED_270':
        adjusted.x -= model.userData.size.z / 2;
        break;
      case 'back':
        adjusted.x += model.userData.size.z / 2;
        break;
      case 'right':
        break;
      default:
        break;
    }

    return adjusted;
  };

  // Áp dụng transform cho preview từ một giao điểm duy nhất
  const applyPreviewTransform = intersection => {
    if (!previewModelRef.current || !intersection) return;

    const mesh = intersection.object;
    const p = intersection.point.clone();
    let rotation = mesh.rotation?.clone?.() || new THREE.Euler();

    if (mesh.userData.wallName) {
      switch (mesh.userData.wallName) {
        case 'left':
          // p.z = mesh.position.z + (previewModelRef.current.userData.size?.x || 0) / 2;
          if (
            p.z <
            mesh.userData.size.min.z +
              (previewModelRef.current.userData.size?.z || 0) / 2
          ) {
            p.z =
              mesh.userData.size.min.z +
              (previewModelRef.current.userData.size?.z || 0) / 2;
          }
          if (
            p.z >
            mesh.userData.size.max.z -
              (previewModelRef.current.userData.size?.z || 0) / 2
          ) {
            p.z =
              mesh.userData.size.max.z -
              (previewModelRef.current.userData.size?.z || 0) / 2;
          }
          break;
        case 'front':
          // p.z = mesh.position.z + (previewModelRef.current.userData.size?.x || 0) / 2;
          rotation = new THREE.Euler(0, -Math.PI / 2, 0);
          if (
            p.x >
            mesh.userData.size.max.x -
              (previewModelRef.current.userData.size?.z / 2 || 0)
          ) {
            p.x =
              mesh.userData.size.max.x -
              (previewModelRef.current.userData.size?.z / 2 || 0);
          }
          if (
            p.x <
            mesh.userData.size.min.x +
              (previewModelRef.current.userData.size?.z / 2 || 0)
          ) {
            p.x =
              mesh.userData.size.min.x +
              (previewModelRef.current.userData.size?.z / 2 || 0);
          }
          break;
        case 'back':
          // p.z = mesh.position.z + (previewModelRef.current.userData.size?.x || 0) / 2;
          rotation = new THREE.Euler(0, Math.PI / 2, 0);
          if (
            p.x >
            mesh.userData.size.max.x -
              (previewModelRef.current.userData.size?.z || 0)
          ) {
            p.x =
              mesh.userData.size.max.x -
              (previewModelRef.current.userData.size?.z || 0);
          }
          break;
        case 'right':
          // p.z = mesh.position.z + (previewModelRef.current.userData.size?.x || 0) / 2;
          rotation = new THREE.Euler(0, -Math.PI, 0);
          break;
        default:
          break;
      }
      const adjusted = getAdjustedPoint(
        p,
        previewModelRef.current,
        mesh.userData.wallName
      );
      previewModelRef.current.position.copy(adjusted);
    }

    if (mesh.userData.wallName === undefined) {
      const model = findTopLevelParent(mesh);
      const currentCabinet = sceneManager.cabinetManager.getCurrentCabinet();
      const foundModule = currentCabinet.getModuleByGroupUuid(model.uuid);
      const orientation = GeometryUtils.getModuleOrientation(
        foundModule?.group
      );
      switch (orientation) {
        case 'NORMAL':
          break;
        case 'ROTATED_90':
          // p.z = mesh.position.z + (previewModelRef.current.userData.size?.x || 0) / 2;
          rotation = new THREE.Euler(0, -Math.PI / 2, 0);
          break;
        case 'ROTATED_270':
          // p.z = mesh.position.z + (previewModelRef.current.userData.size?.x || 0) / 2;
          rotation = new THREE.Euler(0, -Math.PI / 2, 0);
          break;
        case 'right':
          // p.z = mesh.position.z + (previewModelRef.current.userData.size?.x || 0) / 2;
          rotation = new THREE.Euler(0, -Math.PI, 0);
          break;
        default:
          break;
      }
      const adjusted = getAdjustedPointMesh(
        p,
        previewModelRef.current,
        orientation
      );
      previewModelRef.current.position.copy(adjusted);
    }
    previewModelRef.current.rotation.copy(rotation);
  };

  // Raycast và cập nhật preview (không đụng event)
  const updatePreviewFromPointer = () => {
    if (!sceneRef.current || !previewModelRef.current) return;
    const intersects = raycasterRef.current.intersectObjects(
      sceneRef.current.planToCheck,
      true
    );
    if (intersects.length) {
      applyPreviewTransform(intersects[0]);
    }
  };

  const findTopLevelParent = object => {
    let current = object;
    while (current?.parent && current?.parent?.type !== 'Scene') {
      current = current.parent;
    }
    return current;
  };

  const findTopLevelParentForDoor = object => {
    let current = object;
    while (
      current?.parent &&
      current?.parent?.userData?.type === InsideType.DOOR
    ) {
      current = current.parent;
    }
    return current;
  };

  // Cập nhật preview từ một event pointer (chuẩn: updateMouseFromEvent -> raycast -> apply)
  const updatePreviewFromEvent = event => {
    updateMouseFromEvent(event);
    updatePreviewFromPointer();
  };

  // Thay thế handleMouseDown hiện tại
  const handleMouseDown = event => {
    if (!sceneRef.current) return;

    // KIỂM TRA CLICK VÀO MOVE BUTTON (kiểm tra trước)
    if (event.target.closest('.btn-inside-move')) {
      sceneRef.current.controls && (sceneRef.current.controls.enabled = false);
      isDragInsideRef.current = true;
      isDragInside2Ref.current = true;
      prePosRef.current = meshClickRef.current?.position.clone();
      setShowMoveButton(false); // ẨN BUTTON KHI BẮT ĐẦU DRAG
      sceneRef.current?.removeWireframeBoxes?.();
      return;
    }

    updateMouseFromEvent(event);

    // Ưu tiên: holder (type 10)
    if (childClickRef.current?.userData?.type === 10) {
      const hit = raycasterRef.current.intersectObjects([
        childClickRef.current,
      ]);
      if (hit?.length) {
        sceneRef.current.controls &&
          (sceneRef.current.controls.enabled = false);
        isDragHolderRef.current = true;
        setShowMoveButton(false); // ẨN BUTTON KHI DRAG HOLDER
        return;
      }
    }

    // Kéo handle scale cửa (arrayPointDoor)
    const moves = sceneRef.current.arrayPointDoor || [];
    if (moves.length) {
      const hit = raycasterRef.current.intersectObjects(moves);
      if (hit?.length) {
        const intersected = hit[0].object;
        const point = hit[0].point;

        const s = sceneRef.current;
        s.pIntersect?.copy?.(point);
        s.plane?.setFromNormalAndCoplanarPoint?.(s.normal, s.pIntersect);
        s.shift?.subVectors?.(intersected.position, point);

        isDragDoorRef.current = true;
        s.dragObject = intersected;
        s.controls && (s.controls.enabled = false);

        setShowMoveButton(false); // ẨN BUTTON KHI DRAG DOOR
        return;
      }
    }
  };

  // ========= MOUSEMOVE: kéo preview / inside / holder / door =========
  const handleMouseMoveExtended = event => {
    if (!sceneRef.current) return;

    // Gợi ý con trỏ
    const moves = sceneRef.current.arrayMoves || [];
    let isPointer = false;
    if (moves.length) {
      updateMouseFromEvent(event);
      const hitMove = raycasterRef.current.intersectObjects(moves);
      if (hitMove?.length) isPointer = true;
    }
    if (meshClickRef.current) {
      const hitMesh = raycasterRef.current.intersectObjects([
        meshClickRef.current,
      ]);
      if (hitMesh?.length) isPointer = true;
    }
    document.body.style.cursor = isPointer ? 'pointer' : 'default';

    // 1) Kéo preview (đã có logic trong effect cũ, giữ đơn giản ở đây)
    if (isDraggingRef.current && previewModelRef.current) {
      updatePreviewFromEvent(event);
    }

    // 2) Kéo holder theo mặt cửa
    if (isDragHolderRef.current) {
      updateMouseFromEvent(event);
      if (!meshClickRef.current) return;
      const hit = raycasterRef.current.intersectObjects([meshClickRef.current]);
      if (hit?.length) {
        const p = hit[0].point;
        childClickRef.current.position.y = p.y;
        childClickRef.current.position.z = p.z;

        const currentCabinet = sceneManager.cabinetManager.getCurrentCabinet();
        currentCabinet?.updateHolderPadding?.(
          meshClickRef.current,
          childClickRef.current
        );

        sceneRef.current?.display?.createWireframeBox?.(childClickRef.current);
        setTick(t => t + 1);
      }
    }

    // 3) Kéo inside
    if (isDragInsideRef.current) {
      updateMouseFromEvent(event);
      const boxes = sceneRef.current.boxes || [];
      const hit = raycasterRef.current.intersectObjects(boxes);
      if (hit?.length) {
        const p = hit[0].point;
        const currentCabinet = sceneManager.cabinetManager.getCurrentCabinet();

        const model = findTopLevelParent(meshClickRef.current);
        const foundModule = currentCabinet.getModuleByGroupUuid(model.uuid);

        insideLoaderRef?.current?.moveMesh?.(
          meshClickRef.current,
          p,
          prePosRef.current,
          sceneRef.current,
          currentCabinet,
          foundModule
        );

        sceneRef.current?.removeWireframeBoxes?.();
        sceneRef.current?.createWireframeBox?.(meshClickRef.current);
        sceneRef.current?.handleDrawBorder();

        // XÓA DÒNG CẬP NHẬT BUTTON - không update button khi đang drag
        // updateMoveButtonPosition(meshClickRef.current);

        sceneRef.current?.drawEdgeLine?.();
        sceneRef.current?.display?.removePoints?.();

        setTick(t => t + 1);
      }
    }

    // 4) Kéo handle cửa + snap gợi ý
    if (isDragDoorRef.current) {
      updateMouseFromEvent(event);

      const s = sceneRef.current;
      const currentCabinet = sceneManager.cabinetManager.getCurrentCabinet();

      const model = findTopLevelParent(meshClickRef.current);
      const foundModule = currentCabinet.getModuleByGroupUuid(model.uuid);

      // di chuyển theo plane
      s.plane &&
        raycasterRef.current.ray.intersectPlane(s.plane, s.planeIntersect);
      if (s.dragObject && s.planeIntersect && s.shift) {
        //Tạm thời chặn kh cho kéo cửa xuống quá sàn
        if (s.dragObject.position.y < 0) {
          s.dragObject.position.y = 0;
          return;
        }

        s.dragObject.position.addVectors(s.planeIntersect, s.shift);
      }

      insideLoaderRef?.current?.movePointDoor?.(
        s.dragObject?.userData?.index,
        s.dragObject,
        s.arrayPointDoor,
        meshClickRef.current
      );
      insideLoaderRef?.current?.scaleDoorAdvanced?.(
        s.dragObject?.userData?.index,
        meshClickRef.current,
        s.arrayPointDoor,
        null,
        null,
        foundModule
      );

      const hit = raycasterRef.current.intersectObjects(s.arrayPointDoor, true);

      if (hit?.length) {
        const p = hit[0].point;
        if (
          s.dragObject?.userData?.index === 0 ||
          s.dragObject?.userData?.index === 1
        ) {
          p.y += 0.03;
        } else {
          p.y -= 0.03;
        }

        const result = insideLoaderRef?.current?.getPointDoorRecomment?.(
          p,
          currentCabinet,
          foundModule,
          meshClickRef.current
        );

        const hintPoints = s?.drawPointRecommendDoor?.(
          result,
          0,
          // Number(currentCabinet?.doorType) ?? 0
          doorCornersRef.current,
          meshClickRef.current
        );

        const snapP = p;
        if (
          s.dragObject?.userData?.index === 0 ||
          s.dragObject?.userData?.index === 1
        ) {
          snapP.y -= 0.03;
        } else {
          snapP.y += 0.03;
        }

        const closest = findClosestPoint(
          meshClickRef.current,
          snapP,
          hintPoints,
          SnapDoor.MIN_DISTANCE
        );
        if (closest) {
          closest.scale?.set?.(1.5, 1.5, 1.5);
          closest.material?.color?.set?.(0x16ff00);
        }
        pointSnapRef.current = closest || null;
      }
    }
  };

  // ========= MOUSEUP: chốt kéo các loại =========
  const handleMouseUpExtended = async () => {
    if (!sceneRef.current) return;

    // 2) Thả cửa
    if (isDragDoorRef.current) {
      const s = sceneRef.current;

      const drop = raycasterRef.current.ray.intersectPlane(
        s.plane,
        s.planeIntersect
      );

      if (!drop) return;

      if (pointSnapRef.current) {
        //Cập nhật lại độ cao để set drop chính xác
        drop.y = pointSnapRef.current.position.y;

        const pointPos = pointSnapRef.current.getWorldPosition(
          new THREE.Vector3()
        );
        const meshPos = meshClickRef.current.getWorldPosition(
          new THREE.Vector3()
        );

        const dx = roundTo(Math.abs(pointPos.x - meshPos.x));
        const dz = roundTo(Math.abs(pointPos.z - meshPos.z));
        const limitWidth =
          meshClickRef.current.userData?.limit?.width?.max || LimitDoor.WIDTH;

        const currentCabinet = sceneManager.cabinetManager.getCurrentCabinet();
        const model = findTopLevelParent(meshClickRef.current);
        const foundModule = currentCabinet.getModuleByGroupUuid(model.uuid);

        if (
          meshClickRef.current.userData?.drawerUuid ||
          (!meshClickRef.current.userData?.drawerUuid &&
            Math.max(dx, dz) <= limitWidth)
          // Math.max(dx, dz) <= LimitDoor.WIDTH)
        ) {
          insideLoaderRef?.current?.snapToPointDoorRecommend?.(
            s.dragObject?.userData?.index,
            pointSnapRef.current,
            s.arrayPointDoor,
            meshClickRef.current
          );

          insideLoaderRef?.current?.scaleDoorAdvanced?.(
            s.dragObject?.userData?.index,
            meshClickRef.current,
            s.arrayPointDoor,
            drop,
            currentCabinet,
            foundModule
          );

          //Tạm thời phân biệt cửa cánh kính qua tên
          const materialType = meshClickRef?.current?.userData?.materialType;
          const doorDirection = meshClickRef?.current?.userData?.doorDirection;
          const horizontalType =
            meshClickRef?.current?.userData?.horizontalType;

          if (!materialType?.includes('tron')) {
            insideLoaderRef?.current.cutSpecialDoor(
              foundModule,
              meshClickRef.current,
              materialType,
              doorDirection,
              horizontalType
            );
          }

          setTimeout(async () => {
            await sceneManager?.calculateTotalCost?.({});
          }, 100);
        } else {
          //Scale cửa về giá trị cũ trước đó khi KHÔNG THOẢ MÃN KÍCH THƯƠC TỐI ĐA
          insideLoaderRef?.current?.scaleDoorAdvanced?.(
            s.dragObject?.userData?.index,
            meshClickRef.current,
            s.arrayPointDoorPrev,
            drop,
            currentCabinet,
            foundModule
          );

          setTimeout(async () => {
            await sceneManager?.calculateTotalCost?.({});
          }, 100);
        }
      } else {
        //Scale cửa về giá trị cũ trước đó khi KHÔNG CÓ SNAP
        const currentCabinet = sceneManager.cabinetManager.getCurrentCabinet();
        const model = findTopLevelParent(meshClickRef.current);
        const foundModule = currentCabinet.getModuleByGroupUuid(model.uuid);

        insideLoaderRef?.current?.scaleDoorAdvanced?.(
          s.dragObject?.userData?.index,
          meshClickRef.current,
          s.arrayPointDoorPrev,
          drop,
          currentCabinet,
          foundModule
        );

        setTimeout(async () => {
          await sceneManager?.calculateTotalCost?.({});
        }, 100);
      }

      isDragDoorRef.current = false;
      s.dragObject = null;
      s.controls && (s.controls.enabled = true);
      s?.removePointRecommend?.();
      pointSnapRef.current = null;

      // HIỂN THỊ LẠI BUTTON NẾU CÒN MESH
      if (meshClickRef.current) {
        updateMoveButtonPosition(meshClickRef.current);

        doorCornersRef.current = sceneRef.current?.setPointDoor?.(
          meshClickRef.current
        );
      }

      setTick(t => t + 1);
    }

    // 3) Thả holder
    if (isDragHolderRef.current) {
      isDragHolderRef.current = false;
      sceneRef.current.controls && (sceneRef.current.controls.enabled = true);
    }

    if (isDragInsideRef.current) {
      isDragInsideRef.current = false;
      sceneRef.current.controls && (sceneRef.current.controls.enabled = true);
      sceneRef.current?.display?.removeBoxes?.();
      sceneRef.current?.display?.removePoints?.();
      sceneRef.current?.removeWireframeBoxes?.();

      if (meshClickRef.current) {
        const currentCabinet = sceneManager.cabinetManager.getCurrentCabinet();
        const model = findTopLevelParent(meshClickRef.current);
        const foundModule = currentCabinet.getModuleByGroupUuid(model.uuid);
        await insideLoaderRef.current.adjustBackPanelForHPanel(
          foundModule,
          sceneManager
        );
      }
      await sceneManager?.calculateTotalCost?.({});
      // HIỂN THỊ LẠI BUTTON NẾU CÒN MESH
      if (meshClickRef.current) {
        updateMoveButtonPosition(meshClickRef.current);
      }

      isDragInside2Ref.current = false;
      // setTick(t => t + 1);
    }
  };

  // ========= DELETE: xoá inside/door/holder =========
  const handleDeleteKeyPress = useCallback(
    async event => {
      if (
        (!meshClickRef.current && !selectedModels.length) ||
        !sceneRef.current ||
        showCabinetEditor ||
        !sceneManager
      )
        return;

      setNavbarKey();
      setTick(t => t + 1);
      if (meshClickRef.current) {
        const currentCabinet = sceneManager.cabinetManager.getCurrentCabinet();

        const model = findTopLevelParent(meshClickRef.current);
        const foundModule = currentCabinet.getModuleByGroupUuid(model.uuid);

        const cbGroup = foundModule?.group;
        if (!cbGroup) return;

        const picked = meshClickRef.current;

        insideLoaderRef?.current?.removeInside(picked, foundModule);

        //Xoá cửa hộc kéo trong tủ thì xoá hết các cửa hộc kéo trong tủ
        if (
          model &&
          picked.userData.frameUuid &&
          picked.userData.type === InsideType.DOOR
        ) {
          // Lọc để giữ lại các phần tử không phải là child drawer
          foundModule.listInside.forEach(inside => {
            if (
              inside.gltf.userData?.frameUuid === picked.userData?.frameUuid &&
              inside.type === InsideType.DOOR
            ) {
              insideLoaderRef?.current?.removeInside(inside.gltf, foundModule);
            }
          });
        }

        meshClickRef.current = null;
        childClickRef.current = null;

        currentCabinet?.findPoint?.();
        sceneRef.current?.removeAllPoints?.();
        sceneRef.current?.display?.removeBoxes?.();
        sceneRef.current?.display?.removePoints?.();
        sceneRef.current?.removeWireframeBoxes?.();
        sceneRef.current?.removeBoxes?.();
        sceneRef.current?.drawEdgeLine?.();
        insideLoaderRef.current?.clearLine();
        insideLoaderRef.current?.clearLabel();
        setShowMoveButton(false);

        setShowNavDesign(false);

        setTick(t => t + 1);
      } else {
        selectedModels.forEach(model => {
          sceneManager.removeCabinetModule(model.uuid);
          sceneManager.positionController.removeModule(model.uuid);
        });
        setSelectedModels([]);
        setSelectedModel(null);
      }
      await sceneRef.current.updateAllCountertopAndBacksplash();
      sceneRef.current.addKitchenLeds();

      setTimeout(async () => {
        await sceneManager?.calculateTotalCost?.({});
      }, 300);
    },

    [selectedModel, showCabinetEditor, sceneManager, selectedModels]
  );

  const handleOtherKeyPress = useCallback(
    async e => {
      if (e.isComposing || e.keyCode === 229) return;

      if (e.altKey && e.code === 'KeyD') {
        // xử lý dim kích thước ở đây
        setIsDimensioning(prev => {
          if (sceneManager)
            if (prev) {
              sceneManager.clearAllCornerPoints();
            } else {
              if (selectedModels.length) {
                selectedModels.forEach(item => {
                  sceneManager.generateCornerPoints(item);
                });
              } else {
                sceneManager.generateCornerPoints();
              }
            }
          return !prev;
        });
      }
      if (e.altKey && e.code === 'KeyQ') {
        // xử lý tính khoảng cách ở đây
        sceneManager.positionController.createDistanceLines();
      }

      if (e.code === 'KeyH') {
        // xử lý ẩn hiện cửa ở đây
        if (showCabinetEditor) return; //nếu đang mở edit nâng cao thì return

        setIsHideDoor(prev => {
          if (sceneManager) {
            ShortcutUtils.visibleDoor(prev, isOpenDoor, sceneManager);

            return !prev;
          }
        });
      }

      if (e.code === 'KeyO') {
        //Bỏ chọn tất cả các model khi nhấn O
        setSelectedModels([]);
        setSelectedModel(null);

        // xử lý đóng mở cửa ở đây
        if (isAnimatingRef.current) {
          return; // chặn spam phím O
        }

        isAnimatingRef.current = true;

        setIsOpenDoor(prev => {
          if (sceneManager) {
            ShortcutUtils.openDoor(prev, isAnimatingRef, sceneManager);

            return !prev;
          }

          //Không có sceneManager thì unlock ngay
          isAnimatingRef.current = false;
        });
      }
    },
    [sceneManager, selectedModel, selectedModels, showCabinetEditor, isOpenDoor]
  );

  // ========= Wire global listeners khi open =========
  useEffect(() => {
    const onKey = async e => {
      // Ignore input fields
      const activeElement = document.activeElement;
      const isTyping =
        activeElement.tagName === 'INPUT' ||
        activeElement.tagName === 'TEXTAREA' ||
        activeElement.isContentEditable;

      if (isTyping) {
        return; // Không làm gì, để người dùng xóa text bình thường
      }

      if (e.code === 'Backspace' || e.code === 'Delete') {
        await handleDeleteKeyPress(e);
      } else {
        await handleOtherKeyPress(e);
      }
    };

    document.addEventListener('keydown', onKey);

    return () => document.removeEventListener('keydown', onKey);
  }, [handleDeleteKeyPress, handleOtherKeyPress]);

  useEffect(() => {
    const onMove = e => {
      // ========= LOGIC SNAP RECOMMEND (THÊM MỚI) =========
      if (
        isDraggingRef.current &&
        previewModelRef.current &&
        sceneRef.current
      ) {
        const canvas = document.getElementById('canvas3d');
        if (!canvas) return;

        const rect = canvas.getBoundingClientRect();
        mousePositionRef.current.x =
          ((e.clientX - rect.left) / rect.width) * 2 - 1;
        mousePositionRef.current.y =
          -((e.clientY - rect.top) / rect.height) * 2 + 1;

        raycasterRef.current.setFromCamera(
          mousePositionRef.current,
          sceneRef.current.camera
        );

        const currentCabinet =
          sceneManager?.cabinetManager?.getCurrentCabinet();
        if (!currentCabinet) {
          updatePreviewFromEvent(e);
          hideSnapLine();
          return;
        }

        // Raycast vào các modules
        const hits = raycasterRef.current.intersectObjects(
          currentCabinet.cabinetGroup,
          true
        );

        if (hits.length) {
          const intersectionPoint = hits[0].point;

          // TÌM MODULE CHỨA INTERSECTION POINT
          const targetModule = findModuleAtPoint(
            intersectionPoint,
            currentCabinet
          );

          if (!targetModule) {
            updatePreviewFromEvent(e);
            hideSnapLine();
            return;
          }

          // LẤY TYPE TỪ draggedModuleRef
          const previewType = draggedModuleRef.current?.type;

          // TYPE 1: Snap dọc (theo Z hoặc X tùy orientation)
          if (previewType === 1) {
            const edges = findClosestZEdges(
              intersectionPoint,
              currentCabinet,
              targetModule
            );

            if (edges && edges.leftEdge && edges.rightEdge) {
              const centerPoint = calculateCenterPointVertical(
                edges.leftEdge,
                edges.rightEdge,
                targetModule,
                intersectionPoint
              );

              if (centerPoint) {
                centerPointRef.current = centerPoint;
                const isNear = isNearCenterPoint(
                  intersectionPoint,
                  centerPoint,
                  previewType,
                  targetModule
                );

                // Hiển thị snap line dọc
                createOrUpdateSnapLine(
                  centerPoint,
                  targetModule,
                  previewType,
                  isNear
                );

                if (isNear) {
                  // SNAP VÀO TRUNG ĐIỂM
                  const snappedPoint = getAdjustedPointMesh(
                    centerPoint.clone(),
                    previewModelRef.current,
                    GeometryUtils.getModuleOrientation(targetModule.group)
                  );
                  previewModelRef.current.position.copy(snappedPoint);
                } else {
                  // VỊ TRÍ BÌNH THƯỜNG
                  updatePreviewFromEvent(e);
                }

                return;
              }
            }
          }

          // TYPE 0: Snap ngang (theo Y)
          else if (previewType === 0) {
            const edges = findClosestYEdges(
              intersectionPoint,
              currentCabinet,
              targetModule
            );

            if (edges && edges.bottomEdge && edges.topEdge) {
              const centerPoint = calculateCenterPointHorizontal(
                edges.bottomEdge,
                edges.topEdge,
                targetModule,
                intersectionPoint
              );

              if (centerPoint) {
                centerPointRef.current = centerPoint;
                const isNear = isNearCenterPoint(
                  intersectionPoint,
                  centerPoint,
                  previewType,
                  targetModule
                );

                // Hiển thị snap line ngang
                createOrUpdateSnapLine(
                  centerPoint,
                  targetModule,
                  previewType,
                  isNear
                );

                if (isNear) {
                  // SNAP VÀO TRUNG ĐIỂM
                  const snappedPoint = getAdjustedPointMesh(
                    centerPoint.clone(),
                    previewModelRef.current,
                    GeometryUtils.getModuleOrientation(targetModule.group)
                  );
                  previewModelRef.current.position.copy(snappedPoint);
                } else {
                  // VỊ TRÍ BÌNH THƯỜNG
                  updatePreviewFromEvent(e);
                }

                return;
              }
            }
          }

          // Fallback: không snap
          updatePreviewFromEvent(e);
          hideSnapLine();
        } else {
          updatePreviewFromEvent(e);
          hideSnapLine();
        }
      }
      // ========= KẾT THÚC LOGIC SNAP RECOMMEND =========

      handleMouseMoveExtended(e);
    };

    const onUp = () => {
      // thả preview nếu có
      if (
        isDraggingRef.current &&
        previewModelRef.current &&
        sceneRef.current
      ) {
        isDraggingRef.current = false;

        const currentCabinet = sceneManager.cabinetManager.getCurrentCabinet();
        const hitsModule = raycasterRef.current.intersectObjects(
          currentCabinet?.cabinetGroup,
          true
        );

        // ========= XÁC NHẬN SNAP KHI THẢCURRENT  (THÊM MỚI) =========
        const dropPoint = (() => {
          const originalDrop = hitsModule[0]?.point;
          if (!originalDrop) return originalDrop;

          const targetModule = findModuleAtPoint(originalDrop, currentCabinet);
          const previewType = draggedModuleRef.current?.type;

          if (
            centerPointRef.current &&
            targetModule &&
            isNearCenterPoint(
              originalDrop,
              centerPointRef.current,
              previewType,
              targetModule
            )
          ) {
            console.log(
              `Snapped to center point! (Type: ${
                previewType === 1 ? 'Dọc' : 'Ngang'
              })`
            );
            return centerPointRef.current.clone();
          }

          return originalDrop;
        })();
        // ========= KẾT THÚC XÁC NHẬN SNAP =========

        sceneRef.current.scene.remove(previewModelRef.current);

        const mesh = hitsModule[0]?.object;
        const model = findTopLevelParent(mesh);
        if (!model) {
          previewModelRef.current = null;
          draggedModuleRef.current = null;
          hideSnapLine();
          return;
        }
        const foundModule = currentCabinet.getModuleByGroupUuid(model.uuid);

        const hauMeshes = [];
        foundModule.group.traverse(child => {
          if (child.isMesh && child.name.includes('HAU')) {
            hauMeshes.push(child);
          }
        });

        // Raycaster trực tiếp trên array mesh (không cần group)
        const hits1 = raycasterRef.current.intersectObjects(hauMeshes, true);
        const originalMeshName = hits1[0]?.object.name;

        let typeHau;
        if (
          originalMeshName &&
          foundModule.cabinetType.toLowerCase().includes('corner')
        ) {
          if (originalMeshName.includes('HAU-1')) {
            typeHau = TypeConnerModule.SUB;
          } else if (originalMeshName.includes('HAU-2')) {
            typeHau = TypeConnerModule.MAIN;
          }
        }

        if (currentCabinet && foundModule && dropPoint) {
          loadRealModelWithInsideLoader(
            draggedModuleRef.current,
            dropPoint,
            foundModule,
            currentCabinet,
            typeHau
          );
        }
        previewModelRef.current = null;
        draggedModuleRef.current = null;
        hideSnapLine(); // ẨN LINE SAU KHI THẢ
      }

      handleMouseUpExtended();
      // setTick(t => t + 1);
    };

    const onDown = e => handleMouseDown(e);
    const onClick = e => handleCanvasClick(e);

    document.addEventListener('mousemove', onMove);
    document.addEventListener('mouseup', onUp);
    document.addEventListener('mousedown', onDown);
    document.addEventListener('click', onClick);

    return () => {
      document.removeEventListener('mousemove', onMove);
      document.removeEventListener('mouseup', onUp);
      document.removeEventListener('mousedown', onDown);
      document.removeEventListener('click', onClick);

      // Cleanup snap line khi unmount
      if (snapLineRef.current && sceneRef.current) {
        sceneRef.current.scene?.remove(snapLineRef.current);
        snapLineRef.current.geometry?.dispose();
        snapLineRef.current.material?.dispose();
        snapLineRef.current = null;
      }
    };
  }, [
    sceneManager,
    selectedModel,
    selectedModels,
    showCabinetEditor,
    liftSupport,
  ]);

  // Thêm useEffect để update button khi camera thay đổi
  useEffect(() => {
    if (!meshClickRef.current || !showMoveButton) return;

    const updateButtonOnRender = () => {
      if (meshClickRef.current && showMoveButton) {
        updateMoveButtonPosition(meshClickRef.current);
      }
    };

    // Gọi update mỗi frame
    const intervalId = setInterval(updateButtonOnRender, 16); // ~60fps

    return () => clearInterval(intervalId);
  }, [showMoveButton]);

  // Function để load room data từ server
  const loadRoomFromServer = async roomId => {
    if (!roomId || !sceneRef.current) return;

    setIsLoadingRoom(true);
    try {
      // Gọi API lấy chi tiết phòng
      const res = await callApi({
        endpoint: `rooms/v3/rooms/${roomId}`,
        method: 'GET',
      });

      const roomData = res?.data?.result?.data;

      if (!roomData) {
        throw new Error('Không tìm thấy dữ liệu phòng');
      }
      setCurrentRoomData(roomData);
      // Import scene data nếu có
      if (roomData) {
        let attributes;
        try {
          attributes = JSON.parse(roomData?.room_design_data);
        } catch (parseErr) {
          console.error('Failed to parse room design data:', parseErr);
          openMessageWarning({ content: t('Room design data is corrupted') });
          return;
        }
        const floorSize = {
          width: roomData.width_floor,
          depth: roomData.depth_floor,
        };
        attributes.floorSize = floorSize;
        attributes.floorTexture = roomData.texture_floor;
        attributes.wallHeight = roomData.height_wall;
        attributes.wallTexture = roomData.texture_wall;
        sceneRef.current.importSceneData(attributes);

        const repeatBy = calcFloorRepeat(
          roomData.width_floor,
          roomData.depth_floor
        );

        const foundTex = FLOOR_TEXTURES.find(
          t => t.img === roomData.texture_floor
        );

        const newAppearance = {
          wallColor: roomData.texture_wall || '#FCFCFC',
          floorTexId: foundTex ? foundTex.id : null,
          floorRepeat: repeatBy,
        };

        setAppearance(newAppearance);
      }

      openMessageSuccess({ content: t('Room loaded successfully!') });
    } catch (error) {
      setIsLoadingRoom(false);
      console.error('Lỗi khi load phòng:', error);
      openMessageError({
        content:
          error.message ||
          t('Failed to load room.') + ' ' + t('Please try again!'),
      });
    } finally {
      setIsLoadingRoom(false);
    }
  };

  // Handler khi chọn room từ RoomLibrary
  const handleSelectRoom = roomId => {
    setSelectedRoomId(roomId);
    loadRoomFromServer(roomId);
    if (!designId) {
      setOpenExampleRecommend(true);
    }
  };

  const handleChooseDoorAccessory = (e, moduleData, applyToAll) => {
    e.preventDefault();

    const currentCabinet = sceneManager.cabinetManager.getCurrentCabinet();

    if (applyToAll) {
      const lstDoorWithHandles = sceneManager.getAllDoorsWithHandles();

      lstDoorWithHandles.forEach(async door => {
        if (door.userData.beveled === true) return;

        const model = findTopLevelParent(door);
        const foundModule = currentCabinet.getModuleByGroupUuid(model.uuid);

        if (currentCabinet && foundModule) {
          //Thay đổi tay nắm
          const addHandleToCabinet = handle => {
            const data = {
              _id: handle.userData?.id,
              glb: moduleData.model,
              type: moduleData.type,
              gltfUuid: handle.uuid,
              gltf: handle,
              thumbnail_url: handle.userData.thumbnail_url,
              price: moduleData.price,
              name: moduleData.name,
            };
            handle.userData.isInside = true;
            handle.userData.model = moduleData.model;
            foundModule.listInside.push(data);
            foundModule.group.add(handle);
          };

          await insideLoaderRef.current.loadHandleModel(
            moduleData,
            foundModule,
            door,
            addHandleToCabinet
          );
        }
      });
    } else {
      if (!selectedModel) {
        openMessageError({
          content: t('Please select a module to apply handle'),
        });
        return;
      }

      const foundModule = currentCabinet.getModuleByGroupUuid(
        selectedModel.uuid
      );

      foundModule.listInside.forEach(async inside => {
        if (inside.type === InsideType.DOOR && inside.beveled === false) {
          const door = sceneManager.findGLTFByUuid(inside.gltfUuid);

          if (!door) {
            openMessageError({
              content: t('Cannot find a door to add the handle!'),
            });
            return;
          }

          //Thay đổi tay nắm
          const addHandleToCabinet = handle => {
            const data = {
              _id: handle.userData?.id, // Sử dụng UUID của brace làm _id tạm thời
              glb: moduleData.model,
              type: moduleData.type,
              gltfUuid: handle.uuid, 
              gltf: handle,
              thumbnail_url: handle.userData.thumbnail_url,
              price: moduleData.price,
              name: moduleData.name,
            };
            handle.userData.isInside = true;
            handle.userData.model = moduleData.model;
            foundModule.listInside.push(data);
            foundModule.group.add(handle);
          };

          await insideLoaderRef.current.loadHandleModel(
            moduleData,
            foundModule,
            door,
            addHandleToCabinet
          );
        }
      });
    }

    setTimeout(async () => {
      await sceneManager?.calculateTotalCost?.({});
    }, 500);
  };

  useEffect(() => {
    setTimeout(() => {
      sceneRef.current.handleDrawBorder();

      if (selectedModels.length) {
        sceneRef.current.removeBorderSelectedModule();

        selectedModels.forEach(group =>
          sceneRef.current.handleDrawBorderSelectedModule(group)
        );
      } else {
        sceneRef.current.removeBorderSelectedModule();
      }
    }, 50);
  }, [tick]);

  // Kiểm tra cabinetType bắt buộc SAU khi khai báo TẤT CẢ hooks và functions
  if (!cabinetType) {
    console.error('DesignerPage requires cabinetType prop!');
    return (
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: '100vh',
          fontSize: '18px',
          color: 'red',
        }}
      >
        DesignerPage requires cabinetType prop (kitchen, wardrobe, etc.)
      </div>
    );
  }

  return (
    <>
      <DesignerPageContext.Provider value={contextValue}>
        <main className="designer-page">
          {/* ===== UI CŨ (GIỮ NGUYÊN) ===== */}

          <div>
            <HeaderDesign />
          </div>

          <SidebarDesign
            activeKey={sidebarKey}
            setActiveKey={value => {
              setSidebarKey(value);
              if (['kt3', 'kt4'].some(item => value.key === item))
                setNavbarKey('3');
              else setNavbarKey();
            }}
          />

          {/* 3D Canvas */}
          <div id="container__canvas">
            <canvas id="canvas3d" />
            <DimensionOverlay sceneManager={sceneManager} />
          </div>
          <DimensionEditor />
          {auth.accessToken && (
            <>
              {showMoveButton && moveButtonPos && (
                <button
                  className="btn-inside-move"
                  style={{
                    position: 'fixed',
                    top: moveButtonPos.y,
                    left: moveButtonPos.x,
                    transform: 'translate(-50%, -50%)',
                    zIndex: 1000,
                    width: '32px',
                    height: '32px',
                    borderRadius: '50%',
                    backgroundColor: 'white',
                    border: 'none',
                    boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
                    cursor: 'move',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                  }}
                >
                  <span className="w-[16px] h-[16px] flex">
                    <Icon.ICDragPan />
                  </span>
                </button>
              )}

              {/* Bottom Toolbar */}
              <div className="container-toolbar">
                {cabinetType === TypeCabinet.KITCHEN ? (
                  <>
                    <LeftCabinetDesignMenu
                      open={sidebarKey?.active && sidebarKey?.key === 'kt1'}
                      onClose={() =>
                        setSidebarKey(prev => ({ ...prev, active: false }))
                      }
                      moduleType={cabinetType}
                      title={t('Kitchen cabinet')}
                    />
                    <LeftIslandCabinetDesignMenu
                      open={sidebarKey?.active && sidebarKey?.key === 'kt2'}
                      onClose={() =>
                        setSidebarKey(prev => ({ ...prev, active: false }))
                      }
                      moduleType={cabinetType}
                      title={t('Island cabinet')}
                    />
                    <LeftOutsideDesignMenu
                      open={sidebarKey?.active && sidebarKey?.key === 'kt3'}
                      onClose={() =>
                        setSidebarKey(prev => ({ ...prev, active: false }))
                      }
                      moduleType={ModuleType.COUNTERTOP}
                      title={t('Countertop')}
                    />
                    <LeftOutsideDesignMenu
                      open={sidebarKey?.active && sidebarKey?.key === 'kt4'}
                      onClose={() =>
                        setSidebarKey(prev => ({ ...prev, active: false }))
                      }
                      moduleType={ModuleType.BACKSPLASH}
                      title={t('Backsplash')}
                    />
                    <LeftOutsideDesignMenu
                      open={sidebarKey?.active && sidebarKey?.key === 'kt5'}
                      onClose={() =>
                        setSidebarKey(prev => ({ ...prev, active: false }))
                      }
                      moduleType={ModuleType.LED_DECOR}
                      title={t('Lighting')}
                    />
                  </>
                ) : (
                  <>
                    <LeftCabinetDesignMenu
                      open={
                        sidebarKey?.active &&
                        ['wr1', 'sc1'].includes(sidebarKey?.key)
                      }
                      onClose={() =>
                        setSidebarKey(prev => ({ ...prev, active: false }))
                      }
                      moduleType={cabinetType}
                      title={t('Frame')}
                    />
                    <LeftInsideCustomDesignMenu
                      open={
                        sidebarKey?.active &&
                        ['wr2', 'sc2'].includes(sidebarKey?.key)
                      }
                      onClose={() =>
                        setSidebarKey(prev => ({ ...prev, active: false }))
                      }
                      onDragStart={handleDragStart} // drag từ thẻ img trong CardProduct
                      title={t('Partition')}
                    />
                    <LeftAccessoryDesignMenu
                      open={
                        sidebarKey?.active &&
                        ['wr3', 'sc3'].includes(sidebarKey?.key)
                      }
                      onClose={() =>
                        setSidebarKey(prev => ({ ...prev, active: false }))
                      }
                      moduleType={cabinetType}
                      title={t('Accessories')}
                      onDragStart={handleDragStart}
                    />

                    <LeftDoorDesignMenu
                      open={
                        sidebarKey?.active &&
                        ['wr4', 'sc4'].includes(sidebarKey?.key)
                      }
                      onClose={() =>
                        setSidebarKey(prev => ({ ...prev, active: false }))
                      }
                      moduleType={cabinetType}
                      title={t('Door')}
                      onDragStart={handleDragStart}
                    />
                    <LeftPartitionDesignMenu
                      open={
                        sidebarKey?.active &&
                        ['wr5', 'sc5'].includes(sidebarKey?.key)
                      }
                      onClose={() =>
                        setSidebarKey(prev => ({ ...prev, active: false }))
                      }
                      moduleType={cabinetType}
                      title={t('Handle')}
                      onClickCard={handleChooseDoorAccessory}
                    />

                    <LeftLightingDesignMenu
                      open={
                        sidebarKey?.active &&
                        ['wr6', 'sc6'].includes(sidebarKey?.key)
                      }
                      onClose={() =>
                        setSidebarKey(prev => ({ ...prev, active: false }))
                      }
                      moduleType={cabinetType}
                      title={t('Lighting')}
                      onDragStart={handleDragStart}
                    />
                  </>
                )}
                {cabinetType === TypeCabinet.SHOE && (
                  <>
                    <LeftOutsideDesignMenu
                      open={sidebarKey?.active && sidebarKey?.key === 'sc6'}
                      onClose={() =>
                        setSidebarKey(prev => ({ ...prev, active: false }))
                      }
                      moduleType={ModuleType.BACKSPLASH}
                      // onDragStart={handleDragStart}
                      title={t('Louvered wall')}
                    />
                  </>
                )}

                <div
                  className="container-toolbar-extra relative"
                  style={{ left: sidebarKey?.active ? '358px' : '0px' }}
                >
                  {/* <SliderDesign /> */}
                  <ToolbarDesign
                    selectedModel={selectedModel}
                    selectedModels={selectedModels}
                    sceneManager={sceneManager}
                    isDimensioning={isDimensioning}
                    setIsDimensioning={setIsDimensioning}
                    setIsOpenDoor={setIsOpenDoor}
                    isOpenDoor={isOpenDoor}
                    setIsHideDoor={setIsHideDoor}
                    isHideDoor={isHideDoor}
                    updateCabinetTrimSettings={true}
                  />
                  <DimensionToolbar
                    sceneManager={sceneManager}
                    selectedModels={selectedModels}
                  />
                </div>
              </div>

              {sidebarKey?.active && sidebarKey?.key === 'wallSetupForm' && (
                <>
                  <WallSetupForm
                    open={true}
                    onClose={() =>
                      setSidebarKey(prev => ({ ...prev, active: false }))
                    }
                    onApply={handleApplyWallSettings}
                    initialSceneData={sceneData}
                    initialAppearance={appearance}
                    texturesCatalog={FLOOR_TEXTURES}
                    selectedRoomId={selectedRoomId}
                    initialRoomData={currentRoomData}
                  />
                </>
              )}

              {showCabinetTrimView === true && (
                <>
                  <CabinetTrimView
                    open={true}
                    onClose={() => setShowCabinetTrimView(!showCabinetTrimView)}
                    onApply={handleApplyWallSettings}
                    initialSceneData={sceneData}
                    initialAppearance={appearance}
                    texturesCatalog={FLOOR_TEXTURES}
                    designId={design_id}
                  />
                </>
              )}

              {/* {showCabinetEditor && selectedModel !== null && ( */}
              <CabinetEditor
                open={showCabinetEditor}
                onClose={() => setShowCabinetEditor(false)}
                // onSave={handleSaveModuleEdit}
                selectedModel={selectedModel?.uuid}
              />
              {/* )} */}

              {cabinetType === 'kitchen' ? (
                <>
                  {/* <ResizeMenuDesign
                    open={navbarKey === '2'}
                    onClose={() => setNavbarKey()}
                  /> */}
                  <RightCabinetDesignMenu
                    open={navbarKey === '2'}
                    form={formRightInsideCustomDesignMenu}
                    className={'top-84'}
                    onClose={() => setNavbarKey()}
                  />
                  <RightMaterialMenu
                    open={
                      navbarKey === '3' &&
                      selectedModels.length > 0 &&
                      !meshClickRef?.current
                    }
                    onClose={() => setNavbarKey()}
                    title={t('Customize cabinet frame')}
                  />
                  <RightCountertopCustomDesign
                    open={
                      navbarKey === '3' &&
                      meshClickRef?.current?.userData?.type ===
                        ModuleType.COUNTERTOP
                    }
                    onClose={() => setNavbarKey()}
                    title={t('Customize countertop')}
                  />
                  <RightBacksplashCustomDesign
                    open={
                      navbarKey === '3' &&
                      meshClickRef?.current?.userData?.type ===
                        ModuleType.BACKSPLASH
                    }
                    onClose={() => setNavbarKey()}
                    title={t('Customize backsplash')}
                  />
                  <RightApplyDoorChangesToAll
                    open={navbarKey === 'door-multiple-change'}
                    onClose={() => setNavbarKey()}
                  />
                  <RightDoorAccessoryDesignMenu
                    open={openRightDoorAccessoryDesignMenu}
                    className={'top-84'}
                    title={t('Door accessories')}
                    onClose={() => setOpenRightDoorAccessoryDesignMenu(false)}
                    onClickCard={handleChooseDoorAccessory}
                  />
                </>
              ) : (
                <>
                  <RightMaterialMenu
                    open={
                      navbarKey === '3' &&
                      (selectedModels.length > 0 ||
                        meshClickRef?.current?.userData?.type ===
                          InsideType.DOOR)
                    }
                    onClose={() => setNavbarKey()}
                    title={t('Customize')}
                    selectedType={
                      navbarKey === '3' &&
                      meshClickRef?.current?.userData?.type === InsideType.DOOR
                        ? 'door'
                        : null
                    }
                  />
                  <RightCabinetDesignMenu
                    open={
                      selectedModels.length > 0 &&
                      !meshClickRef?.current &&
                      navbarKey === '2'
                    }
                    form={formRightInsideCustomDesignMenu}
                    className={'top-84'}
                  />
                  <RightInsideDesignMenu
                    open={
                      meshClickRef?.current &&
                      meshClickRef?.current?.userData?.type !==
                        InsideType.DOOR &&
                      navbarKey === '2'
                    }
                    form={formRightInsideCustomDesignMenu}
                    className={'top-84'}
                  />
                  {/* Thông số cửa */}
                  <RightDoorWardrobeDesignMenu
                    open={
                      (meshClickRef?.current?.userData?.type ===
                        InsideType.DOOR ||
                        meshClickRef?.current?.userData?.type ===
                          InsideType.DOOR_CLONE) &&
                      navbarKey === '2'
                    }
                    form={formRightInsideCustomDesignMenu}
                    className={'top-84'}
                    title={t('Specification')}
                  />
                  <RightDoorMirrorDesignMenu
                    open={
                      meshClickRef?.current?.userData?.type ===
                        InsideType.MIRROR_DOOR && navbarKey === '2'
                    }
                    form={formRightInsideCustomDesignMenu}
                    className={'top-84'}
                    title={t('Specification')}
                  />
                  <RightDoorAccessoryDesignMenu
                    open={openRightDoorAccessoryDesignMenu}
                    className={'top-84'}
                    title={t('Door accessories')}
                    onClose={() => setOpenRightDoorAccessoryDesignMenu(false)}
                    onClickCard={handleChooseDoorAccessory}
                  />
                  <RightLiftSupportDesignMenu
                    open={openRightLiftSupportDesignMenu}
                    className={'top-84'}
                    title={t('Lift Support')}
                    onClose={() => setOpenRightLiftSupportDesignMenu(false)}
                    onClickCard={handleChooseDoorAccessory}
                  />
                  <RightApplyDoorChangesToAll
                    open={navbarKey === 'door-multiple-change'}
                    onClose={() => setNavbarKey()}
                  />
                </>
              )}
              <SelectedModel />
            </>
          )}

          <SaveLibraryDesignModal
            open={openSaveLibraryModal}
            onClose={() => setOpenSaveLibraryModal(false)}
            onSave={
              isDesignLibrary
                ? handleUpdateLibraryDesign
                : handleSaveLibraryDesign
            }
            cabinetType={cabinetType}
            editData={editLibraryData}
          />

          <NavbarDesign
            show={selectedModels.length > 0 || showNavDesign}
            activeKey={navbarKey}
            setActiveKey={setNavbarKey}
          />
        </main>
      </DesignerPageContext.Provider>

      <RoomLibrary
        open={openRoomLibrary && !sale_product}
        onClose={() => {
          setOpenRoomLibrary(false);
        }}
        setSidebarKey={setSidebarKey}
        onSelectRoom={handleSelectRoom}
      />
      <SaveModuleLibraryModal
        open={showSaveLibraryModule}
        onClose={() => setShowSaveLibraryModule(false)}
        onSave={handleSaveLibraryModule}
      />
      <LoadingOverlay visible={isLoadingSave} text={t('Saving design')} />
      <LoadingOverlay visible={isLoadingDesign} text={t('Loading design')} />
      <LoadingOverlay
        visible={isLoadingRoom}
        text={t('Loading room information')}
      />
    </>
  );
};

export default DesignerPage;
